import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
// utils
import {
  checkIsNA,
  convertStringToArrayForOption,
  isEmptyObject,
  savePageStateInSessionStorage,
  Translations
} from '../../../../../../utils';
//restClient
import { aemHostClient, eapiClient, taxonomyHostClient } from '../../../../../../restClient';
// child components
import Checkbox from '../../../../../common/Checkbox';
import MultiLineSelect from '../../../../../common/MultiLineSelect';
import NavListAccordion, { NavListAccordionWrapper } from '../../../../../common/NavListAccordion/NavListAccordion';
import Radiobutton from '../../../../../common/Radio/radioButton';
import SimpleDropdown from '../../../../../common/SimpleDropdown';
//action creator
import { blockUi, unBlockUi } from '../../../../../../actions/actionCreator';
import { reSetNewPoolActiveTabIndex, setBasicDetailAcc, setNewPoolActiveTabIndex, setPoolIdAfterSaveReferesh, setProductNotionalPooling } from '../../../../../CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/actions/actionCreator';
//import {loadIfStateAvailableInSessionStorage, savePageStateInSessionStorage} from '../../../../../../utils';
import classNames from 'classnames';
import CCRRateBox from '../../../../../common/CCRRateBox';
import { setSowSelectedProduct } from '../../../../../createASow/actions/actionCreator';
import "./SowAddPool.css";

class SowAddPool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pools: [],
      // setLocation: this.props.notionalPoolingdata.location.value,
      selectedPoolAcc: [],
      allocationSettings: {
        allocationMethod: '',
        accountSettings: this.props.selectedSowProduct.accountSettings || [],
        nominatedPoolingAccountDisable: [],
        nominatedPoolingOtherAccountDisable: [],
        defaultSettlementAccount: 'SameAsAbove',
        nominatedPoolingAccount: '',
        unauthorizedInterestType: '',
        unauthorisedOD: {
          baseRate: "",
          baseRateCode: "",
          rate: "fixed",
          spread: "",
          maximumInterest: "",
          minimumInterest: "",
          interestRateType: "baseRate"
        },
        interestCredit: {
          baseRate: '',
          baseRateCode: "",
          rate: "fixed",
          spread: "",
          minimumInterest: '',
          maximumInterest: ''
        },
        interestDebit: {
          baseRate: '',
          baseRateCode: '',
          spread: '',
          rate: 'fixed',
          minimumInterest: '',
          maximumInterest: '',
        },
        nominatedPoolingAccountOther: '',
        odLimit: 'N/A',
        other: '',
        sameAsAbove: ''
      },
      isInterestCreditMargin: false,
      isInterestDebitMargin: false,
      isOther: true,
      noOfAccount: 1,
      // currencies: this.props.location.state.currency.classificationNodes,
      poolCurrency: "",
      selectedAccounts: [],
      poolId: '',
      dropDownInvalid: false,
      inputTextBox: false,
      basicDetailsAccounts: [],
      disableCurrencyList: false,
      randomIdx: Math.random().toString(36).slice(2),
      locationValue: (this.props.selectedSowProduct && this.props.selectedSowProduct.location) || {}
    }
    let { caseId, productId } = this.props.match.params;
    this._showAddAccountBtn = false
    this.mode = this.props.location.state.mode
    this.payload = new addPoolPayload(this.mode)
    this.payloadBasicDetail = new basicDetailPayload(this.mode);
    this.payloadAdvanceAllocation = new advanceAllocationPayload(this.mode);
    // this.apiURL = `/product/gls/${this.props.notionalPoolingdata.id}`;
    // this.apiURLBasicDetailAcc = `/product/gls/${productId}/case/${caseId}/account/`;
    this.taxanomyURL = '/product/taxonomies/notionPoolingCountries';
  }

  translations = (word) => {
    return Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  setInputvalue(key, index, value, name, event) {
    let newAccountSetting = this.state.allocationSettings.accountSettings

    if (index === 'creditMarginBaseRate') {
      if ('coveredCreditBalance' in newAccountSetting[key]) {
        newAccountSetting[key].coveredCreditBalance.rate = value
      } else {
        newAccountSetting[key] = {
          coveredCreditBalance: {
            ...newAccountSetting[key].coveredCreditBalance,
            rate: value
          },
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'creditFixedValue') {
      if ('coveredCreditBalance' in newAccountSetting[key]) {
        newAccountSetting[key].coveredCreditBalance.rate = value
      } else {
        newAccountSetting[key] = {
          coveredCreditBalance: {
            ...newAccountSetting[key].coveredCreditBalance,
            rate: value
          },
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'debitMarginBaseRate') {
      if ('coveredDebitBalance' in newAccountSetting[key]) {
        newAccountSetting[key].coveredDebitBalance.rate = value
      } else {
        newAccountSetting[key] = {
          coveredDebitBalance: {
            ...newAccountSetting[key].coveredDebitBalance,
            rate: value,
          },
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'debitFixedValue') {
      if ('coveredDebitBalance' in newAccountSetting[key]) {
        newAccountSetting[key].coveredDebitBalance.rate = value
      } else {
        newAccountSetting[key] = {
          coveredDebitBalance: {
            ...newAccountSetting[key].coveredDebitBalance,
            rate: value,
          },
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'unAuthorisedODFixedValue') {
      if ('unAuthorisedOD' in newAccountSetting[key]) {
        newAccountSetting[key].unAuthorisedOD.rate = value
      } else {
        newAccountSetting[key] = {
          unAuthorisedOD: {
            ...newAccountSetting[key].unAuthorisedOD,
            rate: value
          },
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'unAuthorisedODMarginBaseRate') {
      if ('unAuthorisedOD' in newAccountSetting[key]) {
        newAccountSetting[key].unAuthorisedOD.rate = value
      } else {
        newAccountSetting[key] = {
          unAuthorisedOD: {
            ...newAccountSetting[key].unAuthorisedOD,
            rate: value
          },
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'unauthorisedFloatingInterest') {
      if ('unauthorizedInterestType' in newAccountSetting[key]) {
        newAccountSetting[key].unauthorizedInterestType = value
      } else {
        newAccountSetting[key] = {
          unauthorizedInterestType: value,
          ...newAccountSetting[key]
        }
      }
    } else if (index === 'unauthorisedFixedInterest') {
      if ('unauthorizedInterestType' in newAccountSetting[key]) {
        newAccountSetting[key].unauthorizedInterestType = value
      } else {
        newAccountSetting[key] = {
          unauthorizedInterestType: value,
          ...newAccountSetting[key]
        }
      }
    }

    this.setState({
      allocationSettings: {
        ...this.state.allocationSettings,
        accountSettings: newAccountSetting
      }
    })

    let EventTar = {
      target: {
        name: 'accountSettings',
        value: this.state.allocationSettings.accountSettings
      }
    }
    this._getDataMakePayload(EventTar);
    this.makeAdavnceAllocationPayload(EventTar);
  }

  loadPageState = () => {
    let _state = this.state;
    let unAuthorisedODClone = { ...this.state.allocationSettings.unauthorisedOD }
    let interestCreditClone = { ...this.state.allocationSettings.interestCredit }
    let interestDebitClone = { ...this.state.allocationSettings.interestDebit }
    let id = this.mode === 'edit' ? this.props.location.state.id : null;
    let nominatedPoolingAccountDisable = [];
    let nominatedPoolingOtherAccountDisable = [];

    if (id !== null) {
      //this.props.id;
      let pools = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools;
      let filteredPool = pools.filter(pool => pool.id === id);
      const filterallocationSettings = filteredPool[0].allocationSettings;
      _state['selectedPoolAcc'] = filteredPool[0].accounts;
      _state['isOther'] = typeof filterallocationSettings.other !== 'undefined' && filterallocationSettings.defaultSettlementAccount === 'Other' ? true : false
      nominatedPoolingAccountDisable.push(filterallocationSettings.nominatedPoolingAccount !== '' ? filterallocationSettings.nominatedPoolingAccount : undefined,
        filterallocationSettings.other !== '' ? filterallocationSettings.other : undefined);
      nominatedPoolingOtherAccountDisable.push(filterallocationSettings.nominatedPoolingAccount !== '' ? filterallocationSettings.nominatedPoolingAccount : undefined,
        filterallocationSettings.other !== '' ? filterallocationSettings.other : undefined);

      try {
        _state['allocationSettings'] = {
          allocationMethod: filterallocationSettings.allocationMethod !== undefined ? filterallocationSettings.allocationMethod : 'FairShareAllocation',
          accountSettings: filterallocationSettings.accountSettings,
          defaultSettlementAccount: filterallocationSettings.defaultSettlementAccount !== undefined ? filterallocationSettings.defaultSettlementAccount : 'SameAsAbove',
          interestCredit: filterallocationSettings.interestCredit !== undefined ? filterallocationSettings.interestCredit : interestCreditClone,
          interestDebit: filterallocationSettings.interestDebit !== undefined ? filterallocationSettings.interestDebit : interestDebitClone,
          nominatedPoolingAccount: filterallocationSettings.nominatedPoolingAccount,
          nominatedPoolingAccountDisable: nominatedPoolingAccountDisable,
          nominatedPoolingOtherAccountDisable: nominatedPoolingOtherAccountDisable,
          nominatedPoolingAccountOther: filterallocationSettings.other,
          odLimit: filterallocationSettings.odLimit !== undefined ? filterallocationSettings.odLimit : 'N/A',
          other: filterallocationSettings.other,
          sameAsAbove: filterallocationSettings.sameAsAbove,
          unauthorisedOD: typeof filterallocationSettings.unauthorisedOD !== 'undefined' ? filterallocationSettings.unauthorisedOD : unAuthorisedODClone,
          unauthorizedInterestType: filterallocationSettings.unauthorizedInterestType,
        };
        _state['id'] = filteredPool[0].id;
        _state['lid'] = filteredPool[0].lid;
        this.setState(_state);
        this._updatedPropsValue(filteredPool[0].accounts);
      }
      catch (e) {
        console.log("Error key not found", e);
      }
    }
  }

  fetchListData = () => {
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }
    if (getCurrentDropDownName === 'standAloneAccounts') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
    }

    var CurrentDropDownValueParsed = JSON.parse(getCurrentDropDownValue);
    let accountDetail = [...this.state.selectedAccounts];
    let filteredPool;
    let filterCurrency;

    eapiClient(this.apiURLBasicDetailAcc, { method: 'GET' })
      .then(({ data }) => {
        this.props.setBasicDetailAcc(data.responseData);
        let id = this.mode === 'edit' ? this.props.location.state.id : null;
        let pools = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools;

        filteredPool = pools.filter(pool => pool.id === id);

        if (filteredPool.length > 0) {
          filterCurrency = data.responseData.filter(cur => {
            if (typeof filteredPool[0].poolCurrency !== 'undefined') {
              if (cur.currency.name === filteredPool[0].poolCurrency.value) {
                return cur
              }
            }
            else if (typeof this.state.poolCurrency !== 'undefined') {
              if (cur.currency.name === this.state.poolCurrency) {
                return cur
              }
            }
          });
        } else {
          filterCurrency = data.responseData.filter(cur => {
            if (typeof this.state.poolCurrency !== 'undefined') {
              if (cur.currency.name === this.state.poolCurrency) {
                return cur
              }
            }
          });
        }
        if (getCurrentDropDownName === 'standAloneAccounts' && getCurrentDropDownValue !== null && CurrentDropDownValueParsed !== null) {
          accountDetail[getCurrentDropDownIndex] = CurrentDropDownValueParsed.id;
          this._showAddAccountBtn = true
        }
        let accountListFilter = [];
        // filterCurrency.filter((account, index) =>{
        //   this.state.countries.filter(countryList => {
        //     if(countryList.id.split(':').reverse()[1] === account.location.value.split(':').reverse()[1]){
        //       accountListFilter.push(account);
        //     }
        //   })
        // })

        let countryId = this.state.locationValue.value.split(':').reverse()[1];
        filterCurrency.filter((account, index) => {
          if (countryId !== undefined && countryId === account.location.value.split(':').reverse()[1]) {
            accountListFilter.push(account);
          }
        })

        this.setState({
          basicDetailsAccounts: accountListFilter,
          selectedAccounts: accountDetail,
        })

        let localObject = { target: { name: 'poolCurrency', value: this.state.poolCurrency } }
        this._getDataMakePayload(localObject);
        this.makeBasicDetailPayload(localObject);
        window.sessionStorage.removeItem("getCurrentDropDown");
        window.sessionStorage.removeItem('key' + getCurrentDropDown);
      });
  }

  loadPageStateBasicDetails = () => {
    //let id = this.mode === 'edit' ? this.props.location.state.id : null;
    let id = this.mode === 'edit' ? this.props.location.state.id : null;
    if (id === null) {
      /*pool id*/
      eapiClient('/product/gls/generate-poolid', { method: 'POST' })
        .then(({ data }) => {
          this.setState({
            genId: data.responseData.id
          })
        });
    } else if (id !== null) {
      this.setState({
        genId: this.props.location.state.id
      })
    }
    if (id !== null) {
      let apiURLForTabStaus;
      if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
        apiURLForTabStaus = `/sows/gls/${this.props.selectedSowProduct.id}/${this.state.genId}/subPoolStatus?isNavigate=true`
      } else {
        apiURLForTabStaus = `/sows/gls/${this.props.selectedSowProduct.id}/${this.state.genId}/subPoolStatus`
      }

      eapiClient(apiURLForTabStaus, { method: 'GET' })
        .then(({ data }) => {
          this.setState({
            status: data.responseData,
          })
        });

      let pools = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools;
      let filteredPool = pools.filter(pool => pool.id === id)[0];

      if (typeof filteredPool.poolCurrency !== 'undefined' && filteredPool.poolCurrency.name !== '') {
        this.setState({
          poolCurrency: filteredPool.poolCurrency.name,
          disableCurrencyList: true
        })
      } else {
        this.setState({
          poolCurrency: '',
          disableCurrencyList: false
        })
      }

      let filterCurrency = this.props.accounts.filter(cur => {
        if (typeof filteredPool.poolCurrency !== 'undefined') {
          return cur.currency.name === filteredPool.poolCurrency.value
        }
      });
      let accountListFilter = [];
      let countryId = this.state.locationValue.value.split(':').reverse()[1];
      filterCurrency.filter((account, index) => {
        if (countryId !== undefined && countryId === account.location.value.split(':').reverse()[1]) {
          accountListFilter.push(account);
        }
      })
      this.setState({
        poolId: filteredPool.poolId,
        selectedAccounts: filteredPool.accounts,
        id: filteredPool.id,
        lid: filteredPool.lid,
        noOfAccount: filteredPool.accounts.length || 1,
        basicDetailsAccounts: accountListFilter
      })
    }
  }

  componentWillMount() {
    /*api call for Notaionl Pooling Data*/
    // loadIfStateAvailableInSessionStorage(this, null, () => {
    //   this.loadPageState();
    // });

    aemHostClient("/aemData/formData/json_sow-sub-pool-basic-accounts")
      .then(({ data }) => {
        this.setState({ basicDetailJson: data.par.staticText_basicDetails });
        this.taxanomyURL = this.translations(data.par.staticText_basicDetails &&
          data.par.staticText_basicDetails.countryTaxonomy);
        this.loadCountryTaxanomy(this.taxanomyURL);
      });


    aemHostClient("/aemData/formData/json_sow-sub-pool-all-closed")
      .then(({ data }) => {
        this.setState({ subPoolJson: data.par });
      });

    aemHostClient("/aemData/formData/json_sow-advantage-allocation-settings")
      .then(({ data }) => {
        if (data.par !== null && data.par !== undefined) {
          this.setState({
            AdvantageAllocationSettingsJson: data.par.staticText_advantageAllocation
          });
        }
      });
  }

  loadCountryTaxanomy = (url) => {
    eapiClient(url)
      .then(({ data }) => {
        this.setState({ countries: data.responseData.classificationNodes });
        const { glsId } = (this.props.match && this.props.match.params) || {};
        // if (glsId) {
        //   eapiClient(`/sows/${glsId}/glses`, { method: 'GET' })
        //     .then(({ data }) => {
        //       if (data.responseData) {
        //         this.payload.setPrePopulateData(data.responseData.notionalPooling.poolingStructure.standAloneAccount);
        //         this.setState({ genId: this.props.location.state.id, locationValue: data.responseData.location })
        //         if (this.mode === 'edit') {
        //           data.responseData.notionalPooling.poolingStructure.pools.filter((item) => {
        //             if (this.props.location.state.id === item.id) {
        //               this.payload.setPrePopulateAllocationSettings(item.allocationSettings);
        //             }
        //           })
        //         }
        //       }
        //     })
        // }

        //       let apiURLForTabStaus;
        //       if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
        //         apiURLForTabStaus = `/product/gls/${this.props.notionalPoolingdata.id}/${this.state.genId}/subPoolStatus?isNavigate=true`
        //       } else {
        //         apiURLForTabStaus = `/product/gls/${this.props.notionalPoolingdata.id}/${this.state.genId}/subPoolStatus`
        //       }
        //       /*api call for Tab Status*/
        //       eapiClient(apiURLForTabStaus, { method: 'GET' })
        //         .then(({ data }) => {
        //           this.setState({ status: data.responseData })
        //         });

        //       loadIfStateAvailableInSessionStorage(this, () => {
        //         this.fetchListData();
        //       }, () => {
        this.loadPageStateBasicDetails();
        this.loadPageState();
        this.getNotionalPoolingCountries();
        this.getAccountPoolTaxanomy();
        //       });
        //     }
        //   });
      });
  }

  getAccountPoolTaxanomy = () => {
    let basicDetailsAccounts = this.state.basicDetailsAccounts;
    if (this.state.basicDetailJson && this.state.basicDetailJson.countryTaxonomy) {
      taxonomyHostClient(this.translations(this.state.basicDetailJson.countryTaxonomy))
        .then(({ data }) => {
          let currentListCountries = data.responseData.classificationNodes;
          if (basicDetailsAccounts !== undefined) {
            basicDetailsAccounts = basicDetailsAccounts.map(item => {
              currentListCountries.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.location.value) {
                    item.location.name = countItem.name
                  }
                }
                return countItem;
              });
              this.setState({ ...basicDetailsAccounts })
            });
          }
        });
    }
  }

  getTaxanomyUrl = () => {
    return this.taxanomyURL = this.translations(this.state.AdvantageAllocationSettingsJson.notionalPoolingTaxonomy);
  }

  getNotionalPoolingCountries = () => {
    let basicDetailsAccounts = this.state.basicDetailsAccounts;
    if (this.state.basicDetailJson && this.state.basicDetailJson.countryTaxonomy) {
      taxonomyHostClient(this.translations(this.state.basicDetailJson.countryTaxonomy))
        .then(({ data }) => {
          if (data.responseData !== undefined) {
            let currentListCountries = data.responseData.classificationNodes;
            if (basicDetailsAccounts !== undefined) {
              basicDetailsAccounts = basicDetailsAccounts.map(item => {
                currentListCountries.filter(countItem => {
                  if ('country' in item) {
                    if (countItem.id === item.location.value) {
                      item.location.name = countItem.name
                    }
                  }
                  return item;
                });
                this.setState([...basicDetailsAccounts]);
              });
            }
          }
        });
    }

  }

  goBack = () => {
    this.props.history.goBack();
  }

  addAccounts = () => {
    this.setState(prevState => ({
      noOfAccount: prevState.noOfAccount + 1,
      showAddAccountBtn: false
    }))
    this._showAddAccountBtn = false
  }

  getDataBasicDetails = (event) => {
    //let _state = this.state;
    //_state[event.target.name] = event.target.value
    this._getDataMakePayload(event);
    this.makeBasicDetailPayload(event);

    let filterAccAccordingCur = this.state.basicDetailsAccounts.filter(cur => cur.currency.name.toLowerCase() === event.target.value.toLowerCase())
    let accountListFilter = [];
    let countryId = this.state.locationValue.value.split(':').reverse()[1];
    filterAccAccordingCur.filter((account, index) => {
      if (countryId === account.location.value.split(':').reverse()[1]) {
        accountListFilter.push(account);
      }
    })
    this.setState({
      dropDownInvalid: false,
      basicDetailsAccounts: accountListFilter,
      selectedAccounts: [],
      noOfAccount: 1,
      inputTextBox: false,
      [event.target.name]: event.target.value
    })
    this._showAddAccountBtn = false
    // this.passAccountDetailsToAdvantage();
  }

  saveStateToSessionOnEdit = () => {
    savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
  }

  handleBasicAccountEditClick = (detail, standAloneAccounts) => {
    var { productId } = this.props.match.params;
    ///case-body/create-new-other-account-ie/:productId/:otherAccountId
    if (detail) {
      this.saveStateToSessionOnEdit();
      this.props.history.push("/case-body/create-new-other-account-np/" + productId + "/" + detail);
    }
    if (standAloneAccounts) {
      window.sessionStorage.setItem("getCurrentDropDown", standAloneAccounts)
    } else {
      window.sessionStorage.removeItem("getCurrentDropDown");
    }
  }

  handleAccountChangeBasicDetails = (index, account) => {
    let accountDetail = [...this.state.selectedAccounts]
    accountDetail[index] = account.id;
    let localObject = {
      target: {
        name: 'multiAccount',
        value: accountDetail
      }
    }
    this.setState({
      selectedAccounts: accountDetail,
      showAddAccountBtn: true
    })
    this._showAddAccountBtn = true
    // this._getDataMakePayload(localObject);
    // this.makeBasicDetailPayload(localObject);
    this.passAccountDetailsToAdvantage(accountDetail);
  }

  handleBlurEvt = (event) => {
    if (event.target.value === '' || event.target.value === 'Please select') {
      this.setState({ dropDownInvalid: true });
    }
  }

  handleBlurEvtForPoolName = (event) => {
    if (event.target.value === '') {
      this.setState({
        inputTextBox: true
      });
    }
  }

  deleteAdditionUser = (index) => {
    let accountDetails = [...this.state.selectedAccounts];
    accountDetails.splice(index, 1)
    this.setState(prevState => ({
      noOfAccount: prevState.noOfAccount - 1,
      selectedAccounts: accountDetails,
      showAddAccountBtn: true
    }), () => { });
    let localObject = { target: { name: 'multiAccount', value: accountDetails } }
    this._showAddAccountBtn = true
    this._getDataMakePayload(localObject);
    this.makeBasicDetailPayload(localObject);
    this.passAccountDetailsToAdvantage(accountDetails);
  }

  toNextpage = () => {
    this.props.history.goBack();
  }


  _getDataMakePayload = (event) => {
    this.payload.setPaylod(event, this.props, this.state);
  }

  makeBasicDetailPayload = (event) => {
    this.payloadBasicDetail.setPaylod(event, this.props, this.state);
  }

  makeAdavnceAllocationPayload = (event) => {
    this.payloadAdvanceAllocation.setPaylod(event, this.props, this.state);
  }

  isEmpty = (obj) => {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }
  //Basic detail save and refresh
  onBasicDetailAndAccountTabDataSubmit = (event) => {
    // payload data
    const apiUrl = `/sows/${this.props.selectedSowProduct.id}/glses`;
    let disableCurrencyList = false;
    const payload = JSON.parse(JSON.stringify(this.props.selectedSowProduct))
    payload.notionalPooling.poolingStructure.pools = [{
      id: this.state.genId,
      lid: this.state.genId,
      accounts: this.state.selectedAccounts,
      poolCurrency: {
        name: this.state.poolCurrency,
        value: this.state.poolCurrency
      }
    }]
    payload.notionalPooling.interestOptimisations = null;
    this.props.blockUi();
    eapiClient(apiUrl, {
      method: "PUT",
      data: JSON.stringify(payload)
    }).then(({ data }) => {
      if (!isEmptyObject(data.responseData)) {
        this.props.setSowSelectedProduct(data.responseData);
        let apiURLForTabStaus;
        if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
          apiURLForTabStaus = `/sows/gls/${this.props.selectedSowProduct.id}/${this.state.genId}/subPoolStatus?isNavigate=true`
        } else {
          apiURLForTabStaus = `/sows/gls/${this.props.selectedSowProduct.id}/${this.state.genId}/subPoolStatus`
        }
        /*api call for Tab Status*/
        if (data.responseData.notionalPooling.poolingStructure.pools !== 'undefined' && data.responseData.notionalPooling.poolingStructure.pools.length === 1) {
          if (data.responseData.notionalPooling.poolingStructure.pools[0].poolCurrency !== undefined) {
            disableCurrencyList = true
          }
        }
        eapiClient(apiURLForTabStaus, { method: 'GET' })
          .then(({ data }) => {
            this.setState({
              status: data.responseData,
              disableCurrencyList: disableCurrencyList
            })
          });
      }
    })
    this.props.unBlockUi();

    // let apiURL2 = `/sows/glses/generate-poolid`;
    // let apiURL = `/sows/${this.props.notionalPoolingdata.id}/glses`;
    // this.payloadBasicDetail.setPaylod(event, this.props, this.state);
    // let disableCurrencyList = false;
    // let payloadData = this.payloadBasicDetail.getPayload();
    // if (payloadData !== undefined && payloadData !== null && !this.isEmpty(payloadData)) {
    //   let requestData = payloadData;
    //   // if(this.props.mode === 'edit') {
    //   //     apiURL = apiURL + "/" + this.state.formData.id;
    //   //   }
    //   eapiClient(apiURL2, {
    //     method: "POST",
    //     dataPool: JSON.stringify(requestData)
    //   })
    //     .then(({ dataPool }) => {
    //       eapiClient(apiURL, {
    //         method: "PUT",
    //         data: JSON.stringify(requestData)
    //       })
    //         .then(({ data }) => {
    //           this.props.setProductNotionalPooling(data.responseData)
    //           let filterallocationSettings;
    //           let id = this.mode === 'edit' ? this.props.location.state.id : null;

    //           if (this.props.PoolIdAfterSaveReferesh === undefined) {
    //             this.props.setPoolIdAfterSaveReferesh(data.responseData.notionalPooling.poolingStructure.pools[data.responseData.notionalPooling.poolingStructure.pools.length - 1].id)
    //           }

    //           // let apiURLForTabStaus;
    //           // if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
    //           //   apiURLForTabStaus = `/product/gls/${this.props.notionalPoolingdata.id}/${this.state.genId}/subPoolStatus?isNavigate=true`
    //           // } else {
    //           //   apiURLForTabStaus = `/product/gls/${this.props.notionalPoolingdata.id}/${this.state.genId}/subPoolStatus`
    //           // }
    //           /*api call for Tab Status*/
    //           // if (payloadData.notionalPooling.poolingStructure.pools !== 'undefined' && payloadData.notionalPooling.poolingStructure.pools.length === 1) {
    //           //   if (payloadData.notionalPooling.poolingStructure.pools[0].poolCurrency !== undefined) {
    //           //     disableCurrencyList = true
    //           //   }
    //           // }
    //           // eapiClient(apiURLForTabStaus, { method: 'GET' })
    //           //   .then(({ data }) => {
    //           //     this.setState({
    //           //       status: data.responseData,
    //           //       disableCurrencyList: disableCurrencyList
    //           //     })
    //           //   });
    //         });
    //     });

    // } else {
    //   this.props.history.goBack();
    // }
  }
  // Advance allocation save and refresh
  onAdvanceAllocationSettingTabDataSubmit = (event) => {
    // payload data
    const apiUrl = `/sows/${this.props.selectedSowProduct.id}/glses`;
    const payload = JSON.parse(JSON.stringify(this.props.selectedSowProduct))
    payload.notionalPooling.poolingStructure.pools = [{
      id: this.state.genId,
      lid: this.state.genId,
      allocationSettings: this.state.allocationSettings
    }]

    eapiClient(apiUrl, {
      method: "PUT",
      data: JSON.stringify(payload)
    }).then(({ data }) => {
      if (!isEmptyObject(data.responseData)) {
        this.props.setSowSelectedProduct(data.responseData)
      }
    })


    // let apiURL = `/product/gls/${this.props.notionalPoolingdata.id}`;
    // console.log('this.state----', this.state);

    // this.payloadAdvanceAllocation.setPaylod(event, this.props, this.state);
    // let payloadData = this.payloadAdvanceAllocation.getPayload();
    // if (payloadData !== undefined && payloadData !== null && !this.isEmpty(payloadData)) {
    //   let requestData = payloadData;
    //   if (Object.keys(payloadData.notionalPooling.poolingStructure.pools[0]).length <= 0) {
    //     payloadData.notionalPooling.poolingStructure.pools = null;
    //   }
    // if(this.props.PoolIdAfterSaveReferesh !== undefined){
    //   payloadData.notionalPooling.poolingStructure.pools[0].id=this.props.PoolIdAfterSaveReferesh;
    //   payloadData.notionalPooling.poolingStructure.pools[0].lid=this.props.PoolIdAfterSaveReferesh
    // }
    // if (requestData.notionalPooling.poolingStructure.pools !== undefined && requestData.notionalPooling.poolingStructure.pools.length > 0) {
    //   let pools = requestData.notionalPooling.poolingStructure.pools;
    //   if (pools.length > 0) {
    //     for (let i = 0; i < pools.length; i++) {
    //       if (pools[i].allocationSettings.allocationMethod === "FairShareAllocation" || pools[i].allocationSettings.allocationMethod === "AbsoluteBalanceAllocation") {
    //         delete pools[i].allocationSettings.nominatedPoolingAccount;
    //       }
    //     }
    //   }
    // }
    // if(this.props.mode === 'edit') {
    //     apiURL = apiURL + "/" + this.state.formData.id;
    //   }
    // eapiClient(apiURL, {
    //   method: "PUT",
    //   data: JSON.stringify(requestData)
    // })
    //   .then(({ data }) => {
    //     if (this.props.PoolIdAfterSaveReferesh === undefined) {
    //       this.props.setPoolIdAfterSaveReferesh(data.responseData.notionalPooling.poolingStructure.pools[data.responseData.notionalPooling.poolingStructure.pools.length - 1].id)
    //     }
    //     let apiURLForTabStaus;
    //     if (this.props.history.location.state !== undefined && this.props.history.location.state.isNavigate !== undefined && this.props.history.location.state.isNavigate === true) {
    //       apiURLForTabStaus = `/product/gls/${this.props.notionalPoolingdata.id}/${this.state.genId}/subPoolStatus?isNavigate=true`
    //     } else {
    //       apiURLForTabStaus = `/product/gls/${this.props.notionalPoolingdata.id}/${this.state.genId}/subPoolStatus`
    //     }
    //     /*api call for Tab Status*/
    //     eapiClient(apiURLForTabStaus, { method: 'GET' })
    //       .then(({ data }) => {
    //         this.setState({ status: data.responseData })
    //       });
    //   });
    // } else {
    // this.props.history.goBack();
    // }
  }

  // Form submit
  onFormSubmit = (event) => {
    const apiUrl = `/sows/${this.props.selectedSowProduct.id}/glses`;
    const payload = JSON.parse(JSON.stringify(this.props.selectedSowProduct))
    payload.notionalPooling.poolingStructure.pools = [{
      id: this.state.genId,
      lid: this.state.genId,
      allocationSettings: this.state.allocationSettings,
      accounts: this.state.selectedAccounts,
      poolCurrency: {
        name: this.state.poolCurrency,
        value: this.state.poolCurrency
      }
    }]
    payload.notionalPooling.interestOptimisations = null;

    eapiClient(apiUrl, {
      method: "PUT",
      data: JSON.stringify(payload)
    }).then(({ data }) => {
      if (!isEmptyObject(data.responseData)) {
        this.props.setSowSelectedProduct(data.responseData)
        this.props.history.goBack()
      }
    })

    // let apiURL = `/product/gls/${this.props.notionalPoolingdata.id}`;
    // this.payload.setPaylod(event, this.props, this.state);
    // let payloadData = this.payload.getPayload();
    // if (payloadData !== undefined && payloadData !== null && !this.isEmpty(payloadData)) {
    //   let requestData = payloadData;
    //   if (Object.keys(payloadData.notionalPooling.poolingStructure.pools[0]).length <= 0 && this.props.location.state.id === undefined) {
    //     payloadData.notionalPooling.poolingStructure.pools = [
    //       {
    //         "poolCurrency": {
    //           "name": "",
    //           "value": ""
    //         },
    //         "accounts": [
    //         ],
    //         "id": this.state.genId,
    //         "lid": this.state.genId
    //       }
    //     ];
    //   }
    //   if (requestData.notionalPooling.poolingStructure.pools !== undefined && requestData.notionalPooling.poolingStructure.pools.length > 0) {
    //     let pools = requestData.notionalPooling.poolingStructure.pools;
    //     if (pools.length > 0) {
    //       for (let i = 0; i < pools.length; i++) {
    //         if (pools[i].allocationSettings.allocationMethod === "FairShareAllocation" || pools[i].allocationSettings.allocationMethod === "AbsoluteBalanceAllocation") {
    //           delete pools[i].allocationSettings.nominatedPoolingAccount;
    //         }
    //       }
    //     }
    //   }
    //   // if(this.props.mode === 'edit') {
    //   //     apiURL = apiURL + "/" + this.state.formData.id;
    //   //   }
    //   eapiClient(apiURL, {
    //     method: "PUT",
    //     data: JSON.stringify(requestData)
    //   })
    //     .then(({ data }) => {
    //       this.props.history.goBack();
    //       this.props.reSetNewPoolActiveTabIndex();
    //     });
    // } else {
    //   this.props.history.goBack();
    //   this.props.reSetNewPoolActiveTabIndex();
    // }
  }

  passAccountDetailsToAdvantage = (acc = []) => {
    this.setState({
      selectedPoolAcc: acc
    });
  }

  handleStandaloneAccountEditClick = (detail) => {
    var { productId } = this.props.match.params;
    ///case-body/create-new-other-account-ie/:productId/:otherAccountId
    if (detail) {
      savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
      this.props.history.push("/case-body/create-new-other-account-np/" + productId + "/" + detail);
    }
  }

  componentWillReceiveProps(nextProps) {
    var _showAddAccountBtn
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key' + getCurrentDropDown);
    if (getCurrentDropDown !== null) {
      var getCurrentDropDownName = getCurrentDropDown.substring(0, getCurrentDropDown.length - 1);
    }
    var CurrentDropDownValueParsed = null
    if (getCurrentDropDownName === 'standAloneAccounts') {
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length - 1);
      CurrentDropDownValueParsed = JSON.parse(getCurrentDropDownValue);
    }

    if (typeof this.state.selectedAccounts !== 'undefined' && this.state.selectedAccounts.length > 0) {
      _showAddAccountBtn = true;
      this._showAddAccountBtn = true;
    } else {
      _showAddAccountBtn = false;
      this._showAddAccountBtn = false;
    }
    let poolCurrency = {
      name: '',
      value: ''
    }

    if (nextProps.location.state.id !== null) {
      let id = nextProps.location.state.id;
      let pools = nextProps.notionalPoolingdata.notionalPooling.poolingStructure.pools;
      let filteredPool = pools.filter(pool => pool.id === id)[0];
      if (typeof filteredPool.poolCurrency !== 'undefined' && filteredPool.poolCurrency.name !== '') {
        this.setState({
          poolCurrency: filteredPool.poolCurrency.name,
          disableCurrencyList: true,
          showAddAccountBtn: _showAddAccountBtn
        })
        this._showAddAccountBtn = _showAddAccountBtn
      }
      else if (CurrentDropDownValueParsed !== null) {
        this.setState(prevState => ({
          poolCurrency: prevState.poolCurrency !== '' ? CurrentDropDownValueParsed.currency.name : poolCurrency,
          disableCurrencyList: false,
          showAddAccountBtn: _showAddAccountBtn
        }))

        this._showAddAccountBtn = _showAddAccountBtn
      }
      // else {
      //   this.setState({
      //     poolCurrency: '',
      //     disableCurrencyList: false
      //   })
      // }

      // var filterCurrency = nextProps.accounts.filter(cur => {
      //   if (typeof filteredPool.poolCurrency !== 'undefined') {
      //     return cur.currency.name === filteredPool.poolCurrency.value
      //   } else if (CurrentDropDownValueParsed !== null) {
      //     return cur.currency.name === CurrentDropDownValueParsed.currency.name
      //   }
      // });

      // let accountListFilter = [];
      // if (nextProps.notionalPoolingdata.location !== undefined) {
      //   let countryId = nextProps.notionalPoolingdata.location.value.split(':').reverse()[1];
      //   filterCurrency.filter((account, index) => {
      //     if (countryId !== undefined && countryId === account.location.value.split(':').reverse()[1]) {
      //       accountListFilter.push(account);
      //     }
      //   })
      // }
      // filterCurrency.filter((account, index) =>{
      //   this.state.countries !== undefined ? this.state.countries.filter(countryList => {
      //     if(countryList.id.split(':').reverse()[1] === account.location.value.split(':').reverse()[1]){
      //       accountListFilter.push(account);
      //     }
      //   }):''
      // })

      this.setState({
        // basicDetailsAccounts: accountListFilter,
        showAddAccountBtn: _showAddAccountBtn
      })
      this._showAddAccountBtn = _showAddAccountBtn

      if (this.props.lang.currentLang.lang !== nextProps.lang.currentLang.lang) {
        this.getTaxanomyUrl();
        this.getNotionalPoolingCountries()
        this.getAccountPoolTaxanomy();
      }
    }

    // let accountDetail = [...this.state.selectedAccounts]
    // if (filterCurrency !== undefined && this.state.selectedAccounts && this.state.selectedAccounts.length > 0 && this.state.noOfAccountSignatories !== this.state.selectedAccounts.length) {
    //   this.setState({
    //     noOfAccount: this.state.selectedAccounts.length,
    //     showAddAccountBtn: _showAddAccountBtn
    //   });
    //   this._showAddAccountBtn = _showAddAccountBtn
    // }

    // if (getCurrentDropDownName === 'standAloneAccounts' && getCurrentDropDownValue !== null && CurrentDropDownValueParsed !== null) {
    //   accountDetail[getCurrentDropDownIndex] = CurrentDropDownValueParsed.id;
    //   var selectedA = [...this.state.selectedPoolAcc];
    //   if (selectedA[getCurrentDropDownIndex] === undefined) {
    //     selectedA.push(CurrentDropDownValueParsed.id)
    //   } else {
    //     selectedA.splice(getCurrentDropDownIndex, 1, CurrentDropDownValueParsed.id)
    //   }
    //   this.setState({
    //     selectedPoolAcc: selectedA
    //   }, () => this.passAccountDetailsToAdvantage(selectedA))

    //   let localObject1 = { target: { name: 'multiAccount', value: this.state.poolCurrency !== '' ? accountDetail : [] } }
    //   let localObject = { target: { name: 'poolCurrency', value: this.state.poolCurrency !== '' ? CurrentDropDownValueParsed.currency.name : '' } }
    //   this.setState(prevState => ({
    //     selectedAccounts: prevState.poolCurrency !== '' ? accountDetail : [],
    //     showAddAccountBtn: _showAddAccountBtn
    //   }))
    //   this._showAddAccountBtn = _showAddAccountBtn
    //   this._getDataMakePayload(localObject1)
    //   this._getDataMakePayload(localObject)
    //   this.makeBasicDetailPayload(localObject1);
    //   this.makeBasicDetailPayload(localObject);
    // }

    let _d = this.state.allocationSettings.accountSettings;
    if (typeof _d === 'undefined') {
      _d = [];
    }
    let localArray = []

    this.state.selectedPoolAcc.map((data, key) => {
      let createObject = {
        coveredCreditBalance: {
          baseRate: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.baseRate : '',
          baseRateCode: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.baseRateCode : '',
          spread: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.spread : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.rate : 'fixed',
          maximumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.maximumInterest : '',
          minimumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.minimumInterest : '',
        },
        coveredDebitBalance: {
          baseRate: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.baseRate : '',
          baseRateCode: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.baseRateCode : '',
          spread: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.spread : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.rate : 'fixed',
          maximumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.maximumInterest : '',
          minimumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.minimumInterest : '',
        },
        unAuthorisedOD: {
          baseRate: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.baseRate : '',
          baseRateCode: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.baseRateCode : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.rate : 'fixed',
          spread: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.spread : '',
          maximumInterest: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.maximumInterest : '',
          minimumInterest: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.minimumInterest : '',
          interestRateType: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.interestRateType : "baseRate",
          fixedRateValue: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.fixedRateValue : ""
        },
        odLimit: typeof _d[key] !== 'undefined' ? _d[key].odLimit : 'N/A',
        unauthorizedInterestType: typeof _d[key] !== 'undefined' ? _d[key].unauthorizedInterestType : '',
        id: data
      }
      localArray.push(createObject);
    })
    if (this.state.selectedPoolAcc.length > 0) {
      this.chnageStateCom(nextProps, localArray);
    }
  }

  _updatedPropsValue = (nextProps) => {
    let _d = this.state.allocationSettings.accountSettings;

    if (typeof _d === 'undefined') {
      _d = [];
    }
    let localArray = []

    nextProps.map((data, key) => {
      let createObject = {
        coveredCreditBalance: {
          baseRate: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.baseRate : '',
          baseRateCode: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.baseRateCode : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.rate : 'fixed',
          spread: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.spread : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.rate : 'fixed',
          maximumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.maximumInterest : '',
          minimumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredCreditBalance ? _d[key].coveredCreditBalance.minimumInterest : ''
        },
        coveredDebitBalance: {
          baseRate: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.baseRate : '',
          baseRateCode: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.baseRateCode : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.rate : 'fixed',
          spread: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.spread : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.rate : 'fixed',
          maximumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.maximumInterest : '',
          minimumInterest: typeof _d[key] !== 'undefined' && _d[key].coveredDebitBalance ? _d[key].coveredDebitBalance.minimumInterest : '',
        },
        unAuthorisedOD: {
          baseRate: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.baseRate : '',
          baseRateCode: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.baseRateCode : '',
          rate: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.rate : 'fixed',
          spread: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.spread : '',
          maximumInterest: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.maximumInterest : '',
          minimumInterest: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.minimumInterest : '',
          interestRateType: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.interestRateType : "baseRate",
          fixedRateValue: typeof _d[key] !== 'undefined' && _d[key].unAuthorisedOD ? _d[key].unAuthorisedOD.fixedRateValue : ""
        },
        odLimit: typeof _d[key] !== 'undefined' ? _d[key].odLimit : 'N/A',
        unauthorizedInterestType: typeof _d[key] !== 'undefined' ? _d[key].unauthorizedInterestType : '',
        id: data
      }
      localArray.push(createObject);
    })
    let _state = this.state;
    _state['selectedPoolAcc'] = nextProps;
    _state['allocationSettings']['accountSettings'] = localArray;
    this.setState(_state);
  }

  chnageStateCom = (nextProps, localArray) => {
    let _state = this.state;
    _state['selectedPoolAcc'] = this.state.selectedPoolAcc;
    _state['allocationSettings']['accountSettings'] = localArray;
    this.setState(_state);
    // let EventTar = {
    //     target : {
    //       name : 'accountSettings',
    //       value :this.state.allocationSettings.accountSettings
    //     }
    // }
    //this.props._getDataMakePayload(EventTar);
    //this.componentWillMount();
  }

  setAllocationOdLimit = (event) => {
    this.setState({
      allocationSettings: {
        ...this.state.allocationSettings,
        odLimit: event.target.checked ? 'N/A' : '',
      }
    })
    this._getDataMakePayload(event);
    this.makeAdavnceAllocationPayload(event)
  }


  getData = (event) => {

    let name = event.target.name;
    let arrValue = name.split("-");
    if (arrValue.length > 1 && arrValue[0] === 'unauthorisedOD') {
      let dataParent = arrValue[0];
      name = arrValue[1];
      let localOBj = {
        ...this.state.allocationSettings.unauthorisedOD,
        [name]: event.target.value
      }

      this.setState({
        allocationSettings: {
          ...this.state.allocationSettings,
          [dataParent]: {
            ...this.state.allocationSettings.unauthorisedOD,
            [name]: event.target.value
          }
        }
      });

      let localObject = {
        target: {
          name: 'unauthorisedOD',
          value: localOBj
        }
      }
      this._getDataMakePayload(localObject);
      this.makeAdavnceAllocationPayload(localObject);
    } else if (arrValue.length > 1 && arrValue[0] === 'interestCredit') {
      let dataParent = arrValue[0];
      name = arrValue[1];
      let localOBj = {
        ...this.state.allocationSettings.interestCredit,
        [name]: event.target.value
      }

      this.setState({
        allocationSettings: {
          ...this.state.allocationSettings,
          [dataParent]: {
            ...this.state.allocationSettings.interestCredit,
            [name]: event.target.value
          }
        }
      });

      let localObject = {
        target: {
          name: 'interestCredit',
          value: localOBj
        }
      }
      this._getDataMakePayload(localObject);
      this.makeAdavnceAllocationPayload(localObject);
    } else if (arrValue.length > 1 && arrValue[0] === 'interestDebit') {
      let dataParent = arrValue[0];
      name = arrValue[1];
      let localOBj = {
        ...this.state.allocationSettings.interestDebit,
        [name]: event.target.value
      }

      this.setState({
        allocationSettings: {
          ...this.state.allocationSettings,
          [dataParent]: {
            ...this.state.allocationSettings.interestDebit,
            [name]: event.target.value
          }
        }
      });

      let localObject = {
        target: {
          name: 'interestDebit',
          value: localOBj
        }
      }
      this._getDataMakePayload(localObject);
      this.makeAdavnceAllocationPayload(localObject);
    } else {
      // let _state = this.state.allocationSettings;
      // _state[event.target.name] = event.target.value
      let accDisable = [];
      let otherAccDisable = [];
      let accSelected = '';
      let otherAccSelected = '';
      let _isOtherOpt = true;
      let setPayload = false;
      event.persist();
      const setEvent = event.target;
      if (event.target.name === "allocationMethod" && event.target.value === "N/A") {
        _isOtherOpt = false;
      }
      if (event.target.name === 'defaultSettlementAccount') {
        if (event.target.value === 'Other') {
          accDisable = [...this.state.allocationSettings.nominatedPoolingAccountDisable];
          accSelected = this.state.allocationSettings.nominatedPoolingAccount;
          otherAccDisable = accDisable.filter(acc => acc === accSelected);
          _isOtherOpt = true;

        } else {
          otherAccDisable = [...this.state.allocationSettings.nominatedPoolingOtherAccountDisable];
          accSelected = this.state.allocationSettings.nominatedPoolingAccount;
          accDisable = otherAccDisable.filter(acc => acc === accSelected);
          otherAccSelected = accSelected;
          _isOtherOpt = false;
        }
      }
      if (event.target.name === 'odLimit') {
        otherAccDisable = [...this.state.allocationSettings.nominatedPoolingOtherAccountDisable]
      }

      this.setState({
        allocationSettings: {
          ...this.state.allocationSettings,
          [event.target.name]: event.target.name === "odLimit" ? checkIsNA(event.target.value) : event.target.value,
          ['nominatedPoolingAccountDisable']: accDisable,
          ['nominatedPoolingOtherAccountDisable']: otherAccDisable,
          ['nominatedPoolingAccount']: accSelected || this.state.allocationSettings.nominatedPoolingAccount,
          ['other']: event.target.value === 'Other' ? '' : otherAccSelected || this.state.allocationSettings.other,
          ['defaultSettlementAccount']: _isOtherOpt ? 'Other' : 'SameAsAbove'
        },
        isOther: _isOtherOpt
      }, () => {
        if (!_isOtherOpt) {
          let localObject = {
            target: {
              name: 'other',
              value: ''
            }
          }
          this._getDataMakePayload(localObject);
          this.makeAdavnceAllocationPayload(localObject);
        }

        //this.setState(_state);
        this._getDataMakePayload(event);
        this.makeAdavnceAllocationPayload(event)
      })
    }

  }

  getDataAccount = (event) => {
    let val = event.target.value;
    let newAccountSetting = this.state.allocationSettings.accountSettings;
    let index = event.target.getAttribute('data-index');

    if (event.target.name === 'coveredCreditBalance') {
      if ('coveredCreditBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredCreditBalance.baseRate = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredCreditBalance: {
            baseRate: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }

    } else if (event.target.name === 'creditCode') {
      if ('coveredCreditBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredCreditBalance.baseRateCode = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredCreditBalance: {
            baseRateCode: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'creditSpread') {
      if ('coveredCreditBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredCreditBalance.spread = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredCreditBalance: {
            spread: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'creditMinInterest') {
      if ('coveredCreditBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredCreditBalance.minimumInterest = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredCreditBalance: {
            minimumInterest: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'creditMaxInterest') {
      if ('coveredCreditBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredCreditBalance.maximumInterest = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredCreditBalance: {
            maximumInterest: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'coveredDebitBalance') {
      if ('coveredDebitBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredDebitBalance.baseRate = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredDebitBalance: {
            baseRate: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'debitCode') {
      if ('coveredDebitBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredDebitBalance.baseRateCode = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredDebitBalance: {
            baseRateCode: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'debitSpread') {
      if ('coveredDebitBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredDebitBalance.spread = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredDebitBalance: {
            spread: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'debitMinInterest') {
      if ('coveredDebitBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredDebitBalance.minimumInterest = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredDebitBalance: {
            minimumInterest: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'debitMaxInterest') {
      if ('coveredDebitBalance' in newAccountSetting[index]) {
        newAccountSetting[index].coveredDebitBalance.maximumInterest = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          coveredDebitBalance: {
            maximumInterest: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'unAuthorisedODbaseRate') {
      if ('unAuthorisedOD' in newAccountSetting[index]) {
        newAccountSetting[index].unAuthorisedOD.baseRate = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          unAuthorisedOD: {
            baseRate: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'unAuthorisedODCode') {
      if ('unAuthorisedOD' in newAccountSetting[index]) {
        newAccountSetting[index].unAuthorisedOD.baseRateCode = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          unAuthorisedOD: {
            baseRateCode: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'unAuthorisedODSpread') {
      if ('unAuthorisedOD' in newAccountSetting[index]) {
        newAccountSetting[index].unAuthorisedOD.spread = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          unAuthorisedOD: {
            spread: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'unAuthorisedODMinInterest') {
      if ('unAuthorisedOD' in newAccountSetting[index]) {
        newAccountSetting[index].unAuthorisedOD.minimumInterest = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          unAuthorisedOD: {
            minimumInterest: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'unAuthorisedODMaxInterest') {
      if ('unAuthorisedOD' in newAccountSetting[index]) {
        newAccountSetting[index].unAuthorisedOD.maximumInterest = val
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          unAuthorisedOD: {
            maximumInterest: val
          },
          odLimit: newAccountSetting[index].odLimit
        }
      }
    } else if (event.target.name === 'odLimitAccountSetting') {
      if ('odLimit' in newAccountSetting[index]) {
        newAccountSetting[index].odLimit = checkIsNA(val)
      } else {
        newAccountSetting[index] = {
          ...newAccountSetting[index],
          odLimit: checkIsNA(val),
        }
      }
    }

    this.setState({
      allocationSettings: {
        ...this.state.allocationSettings,
        accountSettings: newAccountSetting
      }
    })

    let EventTar = {
      target: {
        name: 'accountSettings',
        value: this.state.allocationSettings.accountSettings
      }
    }
    this._getDataMakePayload(EventTar);
    this.makeAdavnceAllocationPayload(EventTar);
  }

  handleAccountChange = (index, account) => {
    let nominatedPoolingAccountDisable = [];
    let nominatedPoolingOtherAccountDisable = [];
    let _state = this.state.allocationSettings;
    let accountDetail = this.state.nominatedPoolingAccount
    accountDetail = index.id;
    let localObject = { target: { name: 'nominatedPoolingAccount', value: accountDetail } }
    nominatedPoolingAccountDisable.push(accountDetail, this.state.allocationSettings.other !== '' ? this.state.allocationSettings.other : undefined);
    nominatedPoolingOtherAccountDisable.push(accountDetail, this.state.allocationSettings.other !== '' ? this.state.allocationSettings.other : undefined);
    _state['nominatedPoolingAccount'] = accountDetail;
    _state['nominatedPoolingAccountDisable'] = nominatedPoolingAccountDisable;
    _state['nominatedPoolingOtherAccountDisable'] = nominatedPoolingOtherAccountDisable;

    this.setState(_state);
    this._getDataMakePayload(localObject);
    this.makeAdavnceAllocationPayload(localObject);
  }

  handleAccountChangeOther = (index, account) => {
    let nominatedPoolingOtherAccountDisable = [];
    let nominatedPoolingAccountDisable = [];
    let _state = this.state.allocationSettings;
    let accountDetail = this.state.nominatedPoolingAccount
    accountDetail = index.id;
    let localObject = { target: { name: 'other', value: accountDetail } }
    nominatedPoolingOtherAccountDisable.push(accountDetail, this.state.allocationSettings.nominatedPoolingAccount !== '' ? this.state.allocationSettings.nominatedPoolingAccount : undefined)
    nominatedPoolingAccountDisable.push(accountDetail, this.state.allocationSettings.nominatedPoolingAccount !== '' ? this.state.allocationSettings.nominatedPoolingAccount : undefined)
    _state['nominatedPoolingAccountDisable'] = nominatedPoolingAccountDisable;
    _state['nominatedPoolingOtherAccountDisable'] = nominatedPoolingOtherAccountDisable;
    _state['other'] = accountDetail
    this.setState(_state);
    this._getDataMakePayload(localObject);
    this.makeAdavnceAllocationPayload(localObject)
  }

  setAccountODLimit = (event, index) => {
    const newAccountSettings = [...this.state.allocationSettings.accountSettings]
    if (newAccountSettings && newAccountSettings[index]) {
      newAccountSettings[index].odLimit = event.target.checked ? 'N/A' : ''
    }

    const eventTarget = {
      target: {
        name: 'accountSettings',
        value: newAccountSettings
      }
    }

    this.setState({
      allocationSettings: {
        ...this.state.allocationSettings,
        accountSettings: newAccountSettings
      }
    })
    this._getDataMakePayload(eventTarget);
    this.makeAdavnceAllocationPayload(eventTarget)
  }

  // _getDataAccount = (event) => {
  //   let _state = this.state;
  //   let dataIndex = event.target.getAttribute('data-index');
  //   let dataParent = event.target.getAttribute('data-parent');
  //   let name = event.target.name;
  //   let value = event.target.value;
  //   let arrValue = name.split("-");
  //   if (arrValue.length > 1) {
  //     dataParent = arrValue[0];
  //     name = arrValue[1];
  //     dataIndex = arrValue[2];
  //   }
  //   let arr = [];
  //   this.state.allocationSettings.accountSettings.map((data, key) => {
  //     let obj = '';

  //     if (dataIndex === key) {

  //       obj = {
  //         coveredCreditBalance: {
  //           baseRate: dataParent === 'coveredCreditBalance' && name === 'baseRate' ? value : data.coveredCreditBalance.baseRate,
  //           baseRateCode: dataParent === 'coveredCreditBalance' && name === 'baseRateCode' ? value : data.coveredCreditBalance.baseRateCode,
  //           rate: dataParent === 'coveredCreditBalance' && name === 'marginBaseRate' ? value : data.coveredCreditBalance.marginBaseRate,
  //           spread: dataParent === 'coveredCreditBalance' && name === 'spread' ? value : data.coveredCreditBalance.spread,
  //           maximumInterest: dataParent === 'coveredCreditBalance' && name === 'maximumInterest' ? value : data.coveredCreditBalance.maximumInterest,
  //           minimumInterest: dataParent === 'coveredCreditBalance' && name === 'minimumInterest' ? value : data.coveredCreditBalance.minimumInterest,
  //         },
  //         coveredDebitBalance: {
  //           baseRate: dataParent === 'coveredDebitBalance' && name === 'baseRate' ? value : data.coveredDebitBalance.baseRate,
  //           baseRateCode: dataParent === 'coveredDebitBalance' && name === 'baseRateCode' ? value : data.coveredDebitBalance.baseRateCode,
  //           rate: dataParent === 'coveredDebitBalance' && name === 'rate' ? value : data.coveredDebitBalance.rate,
  //           spread: dataParent === 'coveredDebitBalance' && name === 'spread' ? value : data.coveredDebitBalance.spread,
  //           maximumInterest: dataParent === 'coveredDebitBalance' && name === 'maximumInterest' ? value : data.coveredDebitBalance.maximumInterest,
  //           minimumInterest: dataParent === 'coveredDebitBalance' && name === 'minimumInterest' ? value : data.coveredDebitBalance.minimumInterest,
  //         },
  //         unAuthorizedOD: {
  //           baseRate: dataParent === 'unAuthorisedOD' && name === 'baseRate' ? value : data.unAuthorizedOD.baseRate,
  //           baseRateCode: dataParent === 'unAuthorisedOD' && name === 'baseRateCode' ? value : data.unAuthorizedOD.baseRateCode,
  //           rate: dataParent === 'unAuthorisedOD' && name === 'rate' ? value : data.unAuthorizedOD.rate,
  //           spread: dataParent === 'unAuthorisedOD' && name === 'spread' ? value : data.unAuthorizedOD.spread,
  //           maximumInterest: dataParent === 'unAuthorisedOD' && name === 'maximumInterest' ? value : data.unAuthorizedOD.maximumInterest,
  //           minimumInterest: dataParent === 'unAuthorisedOD' && name === 'minimumInterest' ? value : data.unAuthorizedOD.minimumInterest,
  //         },
  //         odLimit: name === 'odLimit' ? value : data.odLimit,
  //         unauthorizedInterestType: name === 'unauthorizedInterestType' ? value : data.unauthorizedInterestType,
  //       }
  //       arr.push(obj);
  //     } else {
  //       arr.push(data);
  //     }
  //   });

  //   _state['allocationSettings']['accountSettings'] = arr;
  //   this.setState(_state);
  //   let EventTar = {
  //     target: {
  //       name: 'accountSettings',
  //       value: this.state.allocationSettings.accountSettings
  //     }
  //   }
  //   this._getDataMakePayload(EventTar);
  //   this.makeAdavnceAllocationPayload(EventTar)
  // }

  _render = (pageJson) => {
    const unAuthorisedOD = typeof this.state.allocationSettings.unauthorisedOD !== 'undefined' ? this.state.allocationSettings.unauthorisedOD : {
      baseRate: "",
      baseRateCode: "",
      rate: "fixed",
      spread: "",
      maximumInterest: "",
      minimumInterest: ""
    }

    const interestCredit = this.state.allocationSettings.interestCredit !== undefined ? this.state.allocationSettings.interestCredit : {
      baseRate: '',
      baseRateCode: "",
      rate: "fixed",
      spread: "",
      minimumInterest: '',
      maximumInterest: ''
    }

    const interestDebit = this.state.allocationSettings.interestDebit !== undefined ? this.state.allocationSettings.interestDebit : {
      baseRate: '',
      baseRateCode: "",
      rate: "fixed",
      spread: "",
      minimumInterest: '',
      maximumInterest: ''
    }
    return (this.state.AdvantageAllocationSettingsJson !== undefined && this.state.AdvantageAllocationSettingsJson.defaultValue !== undefined ?
      <ul className="interest-combo-box gdocs-width-100">
        <li style={{ display: 'block' }}>
          <div className="titleLabel">
            {this.translations(this.state.AdvantageAllocationSettingsJson.allocationMethod)}
          </div>
          <div className="titleLabelContent">
            <label className="gdocs-authorised-label">
              {this.translations(this.state.AdvantageAllocationSettingsJson.absBalance)}
              <Radiobutton
                setInputvalue={() => { console.log('Value set') }}
                name="allocationMethod"
                disabled={this.props.customer.roleDetails.customer}
                value='AbsoluteBalanceAllocation'
                _onChange={this.getData}
                _value={this.state.allocationSettings.allocationMethod}
              />
            </label>
            <label className="gdocs-authorised-label">
              {this.translations(this.state.AdvantageAllocationSettingsJson.fairShare)}
              <Radiobutton
                setInputvalue={() => { console.log('Value set') }}
                name="allocationMethod"
                disabled={this.props.customer.roleDetails.customer}
                value="FairShareAllocation"
                _onChange={this.getData}
                _value={this.state.allocationSettings.allocationMethod}
              />
            </label>
            <label className="gdocs-authorised-label">
              {this.translations(this.state.AdvantageAllocationSettingsJson.nominatedPoolAcc)}
              <Radiobutton
                setInputvalue={() => { console.log('Value set') }}
                name="allocationMethod"
                disabled={this.props.customer.roleDetails.customer}
                value="N/A"
                _onChange={this.getData}
                _value={this.state.allocationSettings.allocationMethod}
              />
            </label>
          </div>
        </li>
        {this.state.allocationSettings.allocationMethod === 'N/A' ?
          (<li style={{ display: 'block' }}>
            <div>
              <div className="titleLabel">
                {this.translations(this.state.AdvantageAllocationSettingsJson.nominatedPoolAcc)}
              </div>
              <div className="titleLabelContent">
                <MultiLineSelect
                  defaultValue={this.translations(this.state.basicDetailJson.pleaseselect)}
                  requiredFields={{
                    "row1": ["accountType", "accountNumber", "branchCode", "currency", "location"],
                    "row2": ["accountHolder", "entityNameOther"],
                    "row3": ["bankName", "accountTitle", "tempRefrenceId"]
                  }}
                  multiAccount={true}
                  data={this.props.poolAccounts.filter(acc => acc.currency && acc.currency.name === this.state.poolCurrency) || []}
                  isDisable={this.props.customer.roleDetails.customer}
                  disabledOptions={this.state.allocationSettings.nominatedPoolingAccountDisable}
                  value={this.state.allocationSettings.nominatedPoolingAccount}
                  onEdit={this.handleStandaloneAccountEditClick.bind(this, this.state.allocationSettings.nominatedPoolingAccount)}
                  _onChange={this.handleAccountChange.bind(this)}
                />
              </div>
            </div>
          </li>) : ''
        }


        <li style={{ display: 'block' }}>
          <div className="titleLabel">
            {this.translations(this.state.AdvantageAllocationSettingsJson.defaultAcc)}
          </div>
          {this.state.allocationSettings.allocationMethod === 'N/A' ? <div className="titleLabelContent">
            <label className="gdocs-authorised-label">
              <Radiobutton
                setInputvalue={() => { console.log('Value set') }}
                name="defaultSettlementAccount"
                disabled={this.props.customer.roleDetails.customer}
                _value={this.state.allocationSettings.defaultSettlementAccount !== undefined ? this.state.allocationSettings.defaultSettlementAccount === 'SameAsAbove' ? "SameAsAbove" : false : "SameAsAbove"}
                _onChange={this.getData}
                value="SameAsAbove"
              />
              {this.translations(this.state.AdvantageAllocationSettingsJson.sameAsAbove)}
            </label>
            <label className="gdocs-authorised-label">
              <Radiobutton
                setInputvalue={() => { console.log('Value set') }}
                name="defaultSettlementAccount"
                disabled={this.props.customer.roleDetails.customer}
                _value={this.state.allocationSettings.defaultSettlementAccount !== undefined ? this.state.allocationSettings.defaultSettlementAccount === 'Other' ? "Other" : false : 'Other'}
                _onChange={this.getData}
                value="Other"
              />
              {`${this.translations(this.state.AdvantageAllocationSettingsJson.other)}...`}
            </label>
          </div> : ''}
          {
            this.state.isOther || this.state.allocationSettings.allocationMethod !== 'N/A' ? (<div className="titleLabelContent isother">
              <MultiLineSelect
                defaultValue={this.translations(this.state.basicDetailJson.pleaseselect)}
                requiredFields={{
                  "row1": ["accountType", "accountNumber", "branchCode", "currency", "location"],
                  "row2": ["accountHolder", "entityNameOther"],
                  "row3": ["bankName", "accountTitle", "tempRefrenceId"]
                }}
                multiAccount={true}
                data={this.props.poolAccounts.filter(acc => acc.currency && acc.currency.name === this.state.poolCurrency) || []}
                value={this.state.allocationSettings.other}
                disabledOptions={this.state.allocationSettings.nominatedPoolingOtherAccountDisable}
                isDisable={this.props.customer.roleDetails.customer}
                onEdit={this.handleStandaloneAccountEditClick.bind(this, this.state.allocationSettings.other)}
                _onChange={this.handleAccountChangeOther.bind(this)}
              />
            </div>) : ''
          }
        </li>
        <li>
          <div className="titleLabel">
            {this.translations(this.state.AdvantageAllocationSettingsJson.netBalance)}
          </div>
          <div className="titleLabel">
            {this.translations(this.state.AdvantageAllocationSettingsJson.credit)}
          </div>
          <div className="titleLabelContent labelContentForm">
            <div className="interest-combo-box__input-section">
              <label>{this.translations(this.state.AdvantageAllocationSettingsJson.baseRate)}</label>
              <input
                type="text"
                onChange={this.getData}
                maxLength="50"
                name={`interestCredit-baseRate`}
                disabled={this.props.customer.roleDetails.customer}
                value={interestCredit.baseRate}
              />
            </div>
            {
              !this.props.customer.roleDetails.customer
                ? <div className="interest-combo-box__input-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.code)}</label>
                  <input
                    type="text"
                    onChange={this.getData}
                    maxLength="5"
                    name={`interestCredit-baseRateCode`}
                    value={interestCredit.baseRateCode}
                    placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue && this.state.AdvantageAllocationSettingsJson.defaultValue[1]}
                  />
                </div>
                : ''
            }
            <div className="interest-combo-box__input-section">
              <label>{this.translations(this.state.AdvantageAllocationSettingsJson.spread)}</label>
              <input
                type="text"
                onChange={this.getData}
                name={`interestCredit-spread`}
                disabled={this.props.customer.roleDetails.customer}
                maxLength="7"
                value={interestCredit.spread}
              />
            </div>
            <div className="interest-combo-box__radio-section">
              <label className="radio-label">{this.translations(this.state.AdvantageAllocationSettingsJson.margin)}
                <Radiobutton
                  setInputvalue={() => { console.log('Value set') }}
                  name={`interestCredit-rate`}
                  disabled={this.props.customer.roleDetails.customer}
                  _value={interestCredit.rate}
                  value="marginBaseRate"
                  _onChange={this.getData}
                />
              </label>
            </div>
            <div className="interest-combo-box__radio-section">
              <label className="radio-label">{this.translations(this.state.AdvantageAllocationSettingsJson.fixed)}
                <Radiobutton
                  setInputvalue={() => { console.log('Value set') }}
                  name={`interestCredit-rate`}
                  disabled={this.props.customer.roleDetails.customer}
                  _value={interestCredit.rate}
                  value="fixed"
                  _onChange={this.getData}
                />
              </label>
            </div>
          </div>
          <div className="titleLabelContent labelContentForm">
            <div className="interest-combo-box__input-section">
              <label>Minimum interest</label>
              <input
                placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[5]}
                onChange={this.getData}
                maxLength="10"
                type="text"
                name={`interestCredit-minimumInterest`}
                disabled={this.props.customer.roleDetails.customer}
                value={interestCredit.minimumInterest}
              />
            </div>
            <div className="interest-combo-box__input-section">
              <label>Maximum interest</label>
              <input
                placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[6]}
                onChange={this.getData}
                maxLength="10"
                type="text"
                name={`interestCredit-maximumInterest`}
                disabled={this.props.customer.roleDetails.customer}
                value={interestCredit.maximumInterest}
              />
            </div>
          </div>
        </li>
        <li>
          <div className="titleLabel">
            {this.translations(this.state.AdvantageAllocationSettingsJson.debit)}
          </div>
          <div className="titleLabelContent labelContentForm">
            <div className="interest-combo-box__input-section">
              <label>{this.translations(this.state.AdvantageAllocationSettingsJson.baseRate)}</label>
              <input
                type="text"
                maxLength="50"
                onChange={this.getData}
                name={`interestDebit-baseRate`}
                disabled={this.props.customer.roleDetails.customer}
                value={this.state.allocationSettings.interestDebit.baseRate}
              />
            </div>
            {
              !this.props.customer.roleDetails.customer
                ? <div className="interest-combo-box__input-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.code)}</label>
                  <input
                    type="text"
                    maxLength="5"
                    onChange={this.getData}
                    name={`interestDebit-baseRateCode`}
                    value={this.state.allocationSettings.interestDebit.baseRateCode}
                    placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue && this.state.AdvantageAllocationSettingsJson.defaultValue[1]}
                  />
                </div>
                : ''
            }
            <div className="interest-combo-box__input-section">
              <label>{this.translations(this.state.AdvantageAllocationSettingsJson.spread)}</label>
              <input
                type="text"
                maxLength="7"
                onChange={this.getData}
                name={`interestDebit-spread`}
                disabled={this.props.customer.roleDetails.customer}
                value={this.state.allocationSettings.interestDebit.spread}
              />
            </div>
            <div className="interest-combo-box__radio-section">
              <label>
                {this.translations(this.state.AdvantageAllocationSettingsJson.margin)}
                <Radiobutton
                  setInputvalue={() => { console.log('Value set') }}
                  name={`interestDebit-rate`}
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.allocationSettings.interestDebit.rate}
                  value="marginBaseRate"
                  _onChange={this.getData}
                />
              </label>
            </div>
            <div className="interest-combo-box__radio-section">
              <label>
                {this.translations(this.state.AdvantageAllocationSettingsJson.fixed)}
                <Radiobutton
                  setInputvalue={() => { console.log('Value set') }}
                  name={`interestDebit-rate`}
                  disabled={this.props.customer.roleDetails.customer}
                  _value={this.state.allocationSettings.interestDebit.rate}
                  _onChange={this.getData}
                  value="fixed"
                />
              </label>
            </div>
          </div>
          <div className="titleLabelContent labelContentForm">
            <div className="interest-combo-box__input-section">
              <label>{this.translations(this.state.AdvantageAllocationSettingsJson.minInterest)}</label>
              <input
                placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[5]}
                maxLength="10"
                onChange={this.getData}
                type="text"
                name={`interestDebit-minimumInterest`}
                disabled={this.props.customer.roleDetails.customer}
                value={this.state.allocationSettings.interestDebit.minimumInterest}
              />
            </div>
            <div className="interest-combo-box__input-section">
              <label>{this.translations(this.state.AdvantageAllocationSettingsJson.maxInterest)}</label>
              <input
                placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[6]}
                maxLength="10"
                onChange={this.getData}
                type="text"
                name={`interestDebit-maximumInterest`}
                disabled={this.props.customer.roleDetails.customer}
                value={this.state.allocationSettings.interestDebit.maximumInterest}
              />
            </div>
          </div>
          {/*=======state=========*/}
          <div className="gdocs-odLimit form-group row gdocs-mtop-10">
            <label className="gdocs-odLimit-label col-lg-4" id="allocationSettingsSetOdLimit">
              {this.translations(this.state.AdvantageAllocationSettingsJson.setOdLimit)}
            </label>
            <div className="col-lg-8 col-sm-12">
              <div className='od-limit-container'>
                <input type="text"
                  onChange={this.getData}
                  maxLength="10"
                  name="odLimit"
                  disabled={checkIsNA(this.state.allocationSettings.odLimit, true) || this.props.customer.roleDetails.customer}
                  value={this.state.allocationSettings.odLimit}
                  aria-labelledby="odLimit"
                />
                <div className="input-suffix-sign" style={{ display: 'inline-block' }}>
                  <Checkbox
                    name="odLimit"
                    textMaxLength={10}
                    disabled={this.props.customer.roleDetails.customer}
                    checked={checkIsNA(this.state.allocationSettings.odLimit, true)}
                    onChange={this.setAllocationOdLimit}
                    controlled
                  />
                </div>
                <span className='input-suffix-sign'>
                  {this.translations(this.state.AdvantageAllocationSettingsJson.na)}
                </span>
              </div>
            </div>
          </div>
          {/* {this.state.allocationSettings.odLimit !== 'N/A' &&
            <div className="form-group row">
              <label className="col-lg-4" id={"odLimit" + this.state.randomIdx}>
                {this.translations(this.state.AdvantageAllocationSettingsJson.interestType)}
              </label>
              <div className="col-lg-8 col-sm-12">
                <div className="radiobtn">
                  <label>
                    {this.translations(this.state.AdvantageAllocationSettingsJson.floating)}
                    <Radiobutton
                      setInputvalue={() => { console.log('Value set') }}
                      name={`unauthorisedOD-interestRateType`}
                      disabled={this.props.customer.roleDetails.customer}
                      _value={unAuthorisedOD.interestRateType !== '' ? unAuthorisedOD.interestRateType === 'true' ? 'true' : '' : 'true'}
                      value='true'
                      _onChange={this.getData}
                    />
                  </label>
                </div>
                <div className="radiobtn">
                  <label>
                    {this.translations(this.state.AdvantageAllocationSettingsJson.fixedValue)}
                    <Radiobutton
                      setInputvalue={() => { console.log('Value set') }}
                      name={`unauthorisedOD-interestRateType`}
                      disabled={this.props.customer.roleDetails.customer}
                      _value={unAuthorisedOD.interestRateType === 'false' ? 'false' : ''}
                      value='false'
                      _onChange={this.getData}
                    />
                  </label>
                </div>
              </div>
            </div>} */}
          {
            this.state.allocationSettings.odLimit !== 'N/A' && this.state.AdvantageAllocationSettingsJson && this.state.AdvantageAllocationSettingsJson.guideccrrateUnauthorizedOD ?
              this.generateCCRRateBoxJsx({ ...this.state.AdvantageAllocationSettingsJson.guideccrrateUnauthorizedOD, formData: unAuthorisedOD }, "ccrrate-np-allocation-settings") : null
          }
          {/* {this.state.allocationSettings.odLimit !== 'N/A' && <div className="UnauthorizedODSection ">
            <div className="form-group">
              <div className="col-lg-12 col-sm-12" style={{ paddingLeft: '0', paddingRight: '0' }}>
                <div className="interest-combo-box">
                  <label className="interest-combo-box__label">
                    {this.translations(this.state.AdvantageAllocationSettingsJson.unauthorisedOd)}
                  </label>
                  <div className="interest-combo-box__row clearfix">
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.baseRate)}</label>
                      <input
                        type="text"
                        maxLength="50"
                        name="unauthorisedOD-baseRate"
                        disabled={this.props.customer.roleDetails.customer}
                        onChange={this.getData}
                        value={unAuthorisedOD.baseRate}
                      />
                    </div>
                    {
                      !this.props.customer.roleDetails.customer
                        ? <div className="interest-combo-box__input-section">
                          <label>{this.translations(this.state.AdvantageAllocationSettingsJson.code)}</label>
                          <input
                            type="text"
                            maxLength="5"
                            name="unauthorisedOD-baseRateCode"
                            onChange={this.getData}
                            value={unAuthorisedOD.baseRateCode}
                            placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue && this.state.AdvantageAllocationSettingsJson.defaultValue[1]}
                          />
                        </div>
                        : ''
                    }
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.spread)}</label>
                      <input
                        type="text"
                        maxLength="7"
                        name="unauthorisedOD-spread"
                        disabled={this.props.customer.roleDetails.customer}
                        onChange={this.getData}
                        value={unAuthorisedOD.spread}
                      />
                    </div>
                    <div>
                      <div className="interest-combo-box__radio-section">
                        <label>
                          {this.translations(this.state.AdvantageAllocationSettingsJson.margin)}
                          <Radiobutton
                            setInputvalue={() => { console.log('Value set') }}
                            name={`unauthorisedOD-rate`}
                            _value={unAuthorisedOD.rate}
                            value='marginBaseRate'
                            disabled={this.props.customer.roleDetails.customer}
                            _onChange={this.getData}
                          />
                        </label>
                      </div>
                    </div>
                    <div>
                      <div className="interest-combo-box__radio-section">
                        <label>
                          {this.translations(this.state.AdvantageAllocationSettingsJson.fixed)}
                          <Radiobutton
                            setInputvalue={() => { console.log('Value set') }}
                            name={`unauthorisedOD-rate`}
                            _value={unAuthorisedOD.rate}
                            value='fixed'
                            disabled={this.props.customer.roleDetails.customer}
                            _onChange={this.getData}
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                  <div className="interest-combo-box__row interest-combo-box__row--no-bottom-margin clearfix">
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.minInterest)}</label>
                      <input
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[5]}
                        type="text"
                        maxLength="5"
                        name="unauthorisedOD-minimumInterest"
                        disabled={this.props.customer.roleDetails.customer}
                        value={unAuthorisedOD.minimumInterest}
                        onChange={this.getData}
                      />
                    </div>
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.maxInterest)}</label>
                      <input
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[6]}
                        type="text"
                        maxLength="5"
                        disabled={this.props.customer.roleDetails.customer}
                        name="unauthorisedOD-maximumInterest"
                        value={unAuthorisedOD.maximumInterest}
                        onChange={this.getData}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>} */}
          {/*=======End=========*/}
        </li>
      </ul >
      : '');
  }



  _renderUnAthourizedOD = (index) => {
    let unAuthorisedOD = {};
    if (typeof this.state.allocationSettings.accountSettings !== 'undefined' && typeof this.state.allocationSettings.accountSettings[index].unAuthorisedOD !== undefined) {
      unAuthorisedOD = {
        ...this.state.allocationSettings.accountSettings[index].unAuthorisedOD,
        rate: this.state.allocationSettings.accountSettings[index].unAuthorisedOD.rate ? this.state.allocationSettings.accountSettings[index].unAuthorisedOD.rate : 'fixed'
      }
    } else {
      unAuthorisedOD = {
        baseRate: "",
        baseRateCode: "",
        spread: "",
        rate: "fixed",
        minimumInterest: "",
        maximumInterest: "",
        interestRateType: "baseRate"
      }
    }

    return (
      (this.state.AdvantageAllocationSettingsJson !== undefined && this.state.AdvantageAllocationSettingsJson.defaultValue !== undefined
        ? <div className="UnauthorizedODSection ">
          {this.generateCCRRateBoxJsx({
            ...this.state.AdvantageAllocationSettingsJson.guideccrrateUnauthorizedOD, formIndex: index, formData: this.state.allocationSettings.accountSettings[index].unAuthorisedOD || unAuthorisedOD, isAggregate: true,
            parentFormName: "accountSettings"
          }, "ccrrate-np-allocation-settings-acounts")
          }
          {/* <div className="form-group">
            <div className="col-lg-12 col-sm-12" style={{ paddingLeft: '0', paddingRight: '0' }}>
              <div className="interest-combo-box">
                <label className="interest-combo-box__label">
                  {this.translations(this.state.AdvantageAllocationSettingsJson.unauthorisedOd)}
                </label>
                <div className="interest-combo-box__row clearfix">
                  <div className="interest-combo-box__input-section">
                    <label>{this.translations(this.state.AdvantageAllocationSettingsJson.baseRate)}</label>
                    <input
                      type="text"
                      data-parent="unAuthorisedOD"
                      maxlength="50"
                      data-index={index}
                      name="unAuthorisedODbaseRate"
                      disabled={this.props.customer.roleDetails.customer}
                      onChange={this.getDataAccount}
                      value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.baseRate : ''}
                    />
                  </div>
                  {
                    !this.props.customer.roleDetails.customer
                      ? <div className="interest-combo-box__input-section">
                        <label>{this.translations(this.state.AdvantageAllocationSettingsJson.code)}</label>
                        <input
                          type="text"
                          data-parent="unAuthorisedOD"
                          maxlength="5"
                          name="unAuthorisedODCode"
                          data-index={index}
                          onChange={this.getDataAccount}
                          value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.baseRateCode : ''}
                          placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue && this.state.AdvantageAllocationSettingsJson.defaultValue[1]}
                        />
                      </div>
                      : ''
                  }
                  <div className="interest-combo-box__input-section">
                    <label>{this.translations(this.state.AdvantageAllocationSettingsJson.spread)}</label>
                    <input
                      type="text"
                      data-parent="unAuthorisedOD"
                      name="unAuthorisedODSpread"
                      maxlength="7"
                      disabled={this.props.customer.roleDetails.customer}
                      data-index={index}
                      onChange={this.getDataAccount}
                      value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.spread : ''}
                    />
                  </div>
                  <div className="interest-combo-box__radio-section">
                    <label>
                      {this.translations(this.state.AdvantageAllocationSettingsJson.margin)}
                      <Radiobutton
                        setInputvalue={this.setInputvalue.bind(this, index, 'unAuthorisedODMarginBaseRate')}
                        name={`unAuthorisedOD-rate-${index}`}
                        disabled={this.props.customer.roleDetails.customer}
                        _value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.rate : ''}
                        value='marginBaseRate'
                      />
                    </label>
                  </div>
                  <div className="interest-combo-box__radio-section">
                    <label>
                      {this.translations(this.state.AdvantageAllocationSettingsJson.fixed)}
                      <Radiobutton
                        setInputvalue={this.setInputvalue.bind(this, index, 'unAuthorisedODFixedValue')}
                        name={`unAuthorisedOD-rate-${index}`}
                        disabled={this.props.customer.roleDetails.customer}
                        _value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.rate : ''}
                        value='fixed'
                      />
                    </label>
                  </div>
                </div>
                <div className="interest-combo-box__row interest-combo-box__row--no-bottom-margin clearfix">
                  <div className="interest-combo-box__input-section">
                    <label>
                      {this.translations(this.state.AdvantageAllocationSettingsJson.minInterest)}
                    </label>
                    <input
                      placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[5]}
                      type="text"
                      data-parent="unAuthorisedOD"
                      name="unAuthorisedODMinInterest"
                      maxlength="10"
                      disabled={this.props.customer.roleDetails.customer}
                      data-index={index}
                      value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.minimumInterest : ''}
                      onChange={this.getDataAccount}
                    />
                  </div>
                  <div className="interest-combo-box__input-section">
                    <label>
                      {this.translations(this.state.AdvantageAllocationSettingsJson.maxInterest)}
                    </label>
                    <input
                      placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[6]}
                      type="text"
                      data-parent="unAuthorisedOD"
                      name="unAuthorisedODMaxInterest"
                      maxlength="10"
                      disabled={this.props.customer.roleDetails.customer}
                      data-index={index}
                      value={typeof unAuthorisedOD === 'object' ? unAuthorisedOD.maximumInterest : ''}
                      onChange={this.getDataAccount}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </div>
        : ''
      )
    );
  }

  getTabIndex = (index) => {
    this.props.setNewPoolActiveTabIndex(index);
  }
  _renderBuniessCheckForm = (accId, index) => {
    const { pageJson, basicDetailsAccounts } = this.props;
    // const {basicDetailsAccounts} = this.props;
    let accountFilter = basicDetailsAccounts.filter(account => account.id === accId);
    const account = accountFilter[0];
    return (
      (this.state.AdvantageAllocationSettingsJson !== undefined && this.state.allocationSettings.accountSettings[index] !== undefined && this.state.AdvantageAllocationSettingsJson.defaultValue !== undefined ?
        <div className="contentLoop interest-combo-box" key={index}>
          {
            account !== undefined
              ? <div className="linkCursor">
                <span>{account.accountType !== undefined ? account.accountType.name + ',' : ''}</span>
                <span>{account.accountNumber !== undefined && account.accountNumber !== '' ? account.accountNumber + ',' : ''}</span>
                <span>{account.branchCode !== undefined && account.branchCode !== '' ? account.branchCode + ',' : ''}</span>
                <span>{account.location !== undefined ? account.location.name + ',' : ''}</span>
                <span>{account.currency !== undefined ? account.currency.name : ''}</span>
                <br />
                <span>{account.accountHolder !== undefined ? account.accountHolder.name : ''}</span>
                <br />
                <span>{account.hsbcBankName !== undefined ? account.hsbcBankName.name + ',' : ''}</span>
                <span>{account.bankName !== undefined ? account.bankName + ',' : ''}</span>
                <span>{account.accountTitle !== undefined && account.accountTitle !== '' ? account.accountTitle : ''}</span>
                <span>{account.tempRefrenceId !== undefined && account.tempRefrenceId !== '' ? `(${account.tempRefrenceId})` : ''}</span>
              </div>
              : ''
          }
          <ul>
            <li>
              <div className="titleLabel">
                {this.translations(this.state.AdvantageAllocationSettingsJson.creditBalance)}
              </div>
              <div className="titleLabelContent labelContentForm">
                <div className="interest-combo-box__input-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.baseRate)}</label>
                  <input
                    type="text"
                    data-parent="coveredCreditBalance"
                    data-index={index}
                    maxlength="50"
                    onChange={this.getDataAccount}
                    name="coveredCreditBalance"
                    disabled={this.props.customer.roleDetails.customer}
                    value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.baseRate : ''}
                  />
                </div>
                {
                  !this.props.customer.roleDetails.customer
                    ? <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.code)}</label>
                      <input
                        type="text"
                        data-parent="coveredCreditBalance"
                        data-index={index}
                        maxlength="5"
                        onChange={this.getDataAccount}
                        name="creditCode"
                        value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.baseRateCode : ''}
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue && this.state.AdvantageAllocationSettingsJson.defaultValue[1]}
                      />
                    </div>
                    : ''
                }
                <div className="interest-combo-box__input-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.spread)}</label>
                  <input
                    type="text"
                    data-parent="coveredCreditBalance"
                    data-index={index}
                    maxlength="7"
                    onChange={this.getDataAccount}
                    name="creditSpread"
                    disabled={this.props.customer.roleDetails.customer}
                    value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.spread : ''}
                  />
                </div>
                <div className="interest-combo-box__radio-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.margin)}
                    <Radiobutton
                      setInputvalue={this.setInputvalue.bind(this, index, 'creditMarginBaseRate')}
                      name={`coveredCreditBalance-rate-${index}`}
                      disabled={this.props.customer.roleDetails.customer}
                      value='marginBaseRate'
                      _value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance !== 'undefined' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.rate : ''}
                    />
                  </label>
                </div>
                <div className="interest-combo-box__radio-section">
                  <label>
                    {this.translations(this.state.AdvantageAllocationSettingsJson.fixed)}
                    <Radiobutton
                      setInputvalue={this.setInputvalue.bind(this, index, 'creditFixedValue')}
                      name={`coveredCreditBalance-rate-${index}`}
                      disabled={this.props.customer.roleDetails.customer}
                      value='fixed'
                      _value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance !== 'undefined' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.rate : ''}
                    />
                  </label>
                </div>
                <div className="gdoc-unauthorisedODInline gdocs-mtop-15">
                  <div className="interest-combo-box__row interest-combo-box__row--no-bottom-margin clearfix">
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.minInterest)}</label>
                      <input
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[5]}
                        type="text"
                        name="creditMinInterest"
                        disabled={this.props.customer.roleDetails.customer}
                        data-parent="coveredCreditBalance"
                        data-index={index}
                        maxlength="10"
                        onChange={this.getDataAccount}
                        value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.minimumInterest : ''}
                      />
                    </div>
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.maxInterest)}</label>
                      <input
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[6]}
                        type="text"
                        name="creditMaxInterest"
                        disabled={this.props.customer.roleDetails.customer}
                        data-parent="coveredCreditBalance"
                        maxlength="10"
                        data-index={index}
                        onChange={this.getDataAccount}
                        value={typeof this.state.allocationSettings.accountSettings[index].coveredCreditBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredCreditBalance.maximumInterest : ''}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <div className="titleLabel">
                {this.translations(this.state.AdvantageAllocationSettingsJson.debitBalance)}
              </div>
              <div className="titleLabelContent labelContentForm">
                <div className="interest-combo-box__input-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.baseRate)}</label>
                  <input
                    data-parent="coveredDebitBalance"
                    type="text"
                    data-index={index}
                    maxlength="50"
                    onChange={this.getDataAccount}
                    name="coveredDebitBalance"
                    disabled={this.props.customer.roleDetails.customer}
                    value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.baseRate : ''}
                  />
                </div>
                {
                  !this.props.customer.roleDetails.customer
                    ? <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.code)}</label>
                      <input
                        data-parent="coveredDebitBalance"
                        type="text"
                        maxlength="5"
                        data-index={index}
                        onChange={this.getDataAccount}
                        name="debitCode"
                        value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.baseRateCode : ''}
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue && this.state.AdvantageAllocationSettingsJson.defaultValue[1]}
                      />
                    </div>
                    : ''
                }
                <div className="interest-combo-box__input-section">
                  <label>{this.translations(this.state.AdvantageAllocationSettingsJson.spread)}</label>
                  <input
                    data-parent="coveredDebitBalance"
                    type="text"
                    data-index={index}
                    maxlength="7"
                    onChange={this.getDataAccount}
                    name="debitSpread"
                    disabled={this.props.customer.roleDetails.customer}
                    value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.spread : ''}
                  />
                </div>
                <div className="interest-combo-box__radio-section">
                  <label>
                    {this.translations(this.state.AdvantageAllocationSettingsJson.margin)}
                    <Radiobutton
                      setInputvalue={this.setInputvalue.bind(this, index, 'debitMarginBaseRate')}
                      name={`coveredDebitBalance-rate-${index}`}
                      disabled={this.props.customer.roleDetails.customer}
                      value='marginBaseRate'
                      _value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance !== 'undefined' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.rate : ''}
                      _onChange={this.getDataAccount}
                    />
                  </label>
                </div>
                <div className="interest-combo-box__radio-section">
                  <label>
                    {this.translations(this.state.AdvantageAllocationSettingsJson.fixed)}
                    <Radiobutton
                      setInputvalue={this.setInputvalue.bind(this, index, 'debitFixedValue')}
                      name={`coveredDebitBalance-rate-${index}`}
                      disabled={this.props.customer.roleDetails.customer}
                      value='fixed'
                      _value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance !== 'undefined' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.rate : ''}
                    />
                  </label>
                </div>
                <div className="gdoc-unauthorisedODInline gdocs-mtop-15">
                  <div className="interest-combo-box__row interest-combo-box__row--no-bottom-margin clearfix">
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.minInterest)}</label>
                      <input
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[5]}
                        type="text"
                        maxlength="10"
                        name="debitMinInterest"
                        disabled={this.props.customer.roleDetails.customer}
                        data-parent="coveredDebitBalance"
                        data-index={index}
                        onChange={this.getDataAccount}
                        value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.minimumInterest : ''}
                      />
                    </div>
                    <div className="interest-combo-box__input-section">
                      <label>{this.translations(this.state.AdvantageAllocationSettingsJson.maxInterest)}</label>
                      <input
                        placeholder={this.state.AdvantageAllocationSettingsJson.defaultValue[6]}
                        type="text"
                        name="debitMaxInterest"
                        maxlength="10"
                        disabled={this.props.customer.roleDetails.customer}
                        data-parent="coveredDebitBalance"
                        data-index={index}
                        onChange={this.getDataAccount}
                        value={typeof this.state.allocationSettings.accountSettings[index].coveredDebitBalance === 'object' ? this.state.allocationSettings.accountSettings[index].coveredDebitBalance.maximumInterest : ''}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group row gdocs-mtop-15">
                  <label className="col-lg-4" id={"odLimit" + this.state.randomIdx + index}>
                    {this.translations(this.state.AdvantageAllocationSettingsJson.setOdLimit)}
                  </label>
                  <div className="col-lg-8 col-sm-12">
                    <div className='od-limit-container'>
                      <input
                        type="text"
                        data-parent="coveredDebitBalance"
                        data-index={index}
                        onChange={this.getDataAccount}
                        name='odLimitAccountSetting'
                        disabled={checkIsNA(this.state.allocationSettings.accountSettings[index].odLimit, true) || this.props.customer.roleDetails.customer}
                        value={this.state.allocationSettings.accountSettings[index].odLimit}
                        aria-labelledby={"odLimit" + this.state.randomIdx + index}
                      // ref={node => this[`disableAccountODLimit_${index}`] = node}
                      />
                      <div className="input-suffix-sign" style={{ display: 'inline-block' }}>
                        <Checkbox
                          name={`odLimit${index}`}
                          textMaxLength={10}
                          disabled={this.props.customer.roleDetails.customer}
                          checked={checkIsNA(this.state.allocationSettings.accountSettings[index].odLimit, true)}
                          onChange={(event) => this.setAccountODLimit(event, index)}
                          controlled
                        />
                      </div>
                      <span className="input-suffix-sign">{this.translations(this.state.AdvantageAllocationSettingsJson.na)}</span>
                    </div>
                  </div>
                </div>
                {checkIsNA(this.state.allocationSettings.accountSettings[index].odLimit, true) ? null :
                  <Fragment>
                    {/* <div className="form-group row">
                    <label className="col-lg-4" id={"coveredDebitBalance-unauthorizedInterestType-" + this.state.randomIdx + index} >
                      {this.translations(this.state.AdvantageAllocationSettingsJson.interestType)}
                    </label>
                    <div className="col-lg-8 col-sm-12">
                      <div className="radiobtn">
                        <label>
                          {this.translations(this.state.AdvantageAllocationSettingsJson.floating)}
                          <Radiobutton
                            setInputvalue={this.setInputvalue.bind(this, index, 'unauthorisedFloatingInterest')}
                            name={`coveredDebitBalance-unauthorizedInterestType-${index}`}
                            disabled={this.props.customer.roleDetails.customer}
                            _value={this.state.allocationSettings.accountSettings[index].unauthorizedInterestType !== 'undefined' ? this.state.allocationSettings.accountSettings[index].unauthorizedInterestType : ''}
                            value='true'
                          />
                        </label>
                      </div>
                      <div className="radiobtn">
                        <label>
                          {this.translations(this.state.AdvantageAllocationSettingsJson.fixedValue)}
                          <Radiobutton
                            setInputvalue={this.setInputvalue.bind(this, index, 'unauthorisedFixedInterest')}
                            name={`coveredDebitBalance-unauthorizedInterestType-${index}`}
                            disabled={this.props.customer.roleDetails.customer}
                            _value={this.state.allocationSettings.accountSettings[index].unauthorizedInterestType !== 'undefined' ? this.state.allocationSettings.accountSettings[index].unauthorizedInterestType : ''}
                            value='false'
                          />
                        </label>
                      </div>
                    </div>
                  </div> */}
                    {/* <div> */}
                    {this._renderUnAthourizedOD(index)}
                    {/* </div> */}
                  </Fragment>
                }
              </div>
            </li>
          </ul>
        </div>
        : ''));
  }

  // getBasicDetailsAccountStatus = () => {
  //   return this.props.location && this.props.location.state && this.props.location.state.id && this.props.selectedSowProduct && this.props.selectedSowProduct.notionalPooling && this.props.selectedSowProduct.notionalPooling.poolingStructure &&
  //     this.props.selectedSowProduct.notionalPooling.poolingStructure.pools && this.props.selectedSowProduct.notionalPooling.poolingStructure.pools.length ? 'complete' : 'incomplete'
  // }

  getCCrRateId = (name, fieldPrefix = '', isAggregate, parentFormName, formIndex) => {
    return isAggregate ? `${fieldPrefix}${name}${parentFormName}${formIndex}Field` : `${fieldPrefix || ""}${name}Field`
  }

  generateCCRRateBoxJsx = ({ name, boxLabel, subLabels, subNames, radioValues, isVisible, maxChars, isAggregate, parentFormName, formData, formIndex, defaultValue }, elementKey = 'ccrratebox-ie-odlimit', unauthorisedODData) => {
    const visibilityCss = classNames("form-group row", {
      noDisplay: isVisible === 'false'
    });
    const disabled = this.props.customer.roleDetails.customer
    const boxLabelTranslated = this.translations(boxLabel);
    const currentWord = this.translations(subLabels)
    const convertedArray = (typeof currentWord === "string" && convertStringToArrayForOption(currentWord)) || [];

    const _jsx = (
      <div key={elementKey} className={visibilityCss} id={this.getCCrRateId(name, this.props.fieldPrefix, isAggregate, parentFormName, formIndex)}>
        <div className="col-lg-12 col-sm-12 gdocs-display-inline-block">
          <CCRRateBox
            name={isAggregate ? parentFormName + name + formIndex : name}
            boxLabel={boxLabelTranslated}
            disabled={disabled}
            subLabels={convertedArray}
            subNames={subNames}
            radioValues={radioValues}
            maxChars={maxChars}
            defaultValue={defaultValue}
            _value={formData}
            setInputvalue={(values,) => {
              console.log("🚀 ~ values:", values)
              if (isAggregate === true) {
                const newAccountSetting = [...this.state.allocationSettings[parentFormName]]
                if ('unAuthorisedOD' in newAccountSetting[formIndex]) {
                  newAccountSetting[formIndex].unAuthorisedOD = values
                } else {
                  newAccountSetting[formIndex] = {
                    ...newAccountSetting[formIndex],
                    unAuthorisedOD: values,
                    // odLimit: newAccountSetting[index].odLimit
                  }
                }
                this.setState({
                  allocationSettings: {
                    ...this.state.allocationSettings,
                    accountSettings: newAccountSetting
                  }
                })
                const payloadObject = {
                  target: {
                    name: 'accountSettings',
                    value: newAccountSetting
                  }
                }
                this._getDataMakePayload(payloadObject);
                this.makeAdavnceAllocationPayload(payloadObject);
              }
              else {
                const updatedUnauthorisedData = { ...this.state.allocationSettings.unauthorisedOD, ...values }
                this.setState({
                  allocationSettings: {
                    ...this.state.allocationSettings,
                    unauthorisedOD: updatedUnauthorisedData
                  }
                });
                const payloadObject = {
                  target: {
                    name: 'unauthorisedOD',
                    value: updatedUnauthorisedData
                  }
                }
                this._getDataMakePayload(payloadObject);
                this.makeAdavnceAllocationPayload(payloadObject);
              }
            }}
            fieldPrefix={this.props.fieldPrefix} />
        </div>
      </div>
    );
    return _jsx;
  }

  render() {
    let refrenceIdNew = "New Pool";
    let filterePool = [];
    let poolLength;
    const { pageJson } = this.props;

    if (this.mode === 'edit') {
      filterePool = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools.filter(function (data, key) {
        if (data.id === this.props.location.state.id) {
          poolLength = data.accounts.length;
          return true;
        }
      }.bind(this));
      if (filterePool.length > 0) {
        refrenceIdNew = filterePool[0].refrenceId;
      }

    }

    if (this.props.pageJson1 !== undefined && this.state.subPoolJson !== undefined) {
      let id = this.props.location.state.id
      let filterCurrency;
      let filteredPool;
      let pools = this.props.notionalPoolingdata.notionalPooling.poolingStructure.pools;
      // let pools = sowNotionalPoolJson.notionalPooling.poolingStructure.pools;
      filteredPool = pools.filter(pool => pool.id === id);

      filterCurrency = filteredPool.length > 0 && filteredPool[0].poolCurrency !== undefined ? filteredPool[0].poolCurrency.name : ''
      // if(filteredPool.length > 0){
      //   filterCurrency = data.responseData.filter(cur => {
      //     if(typeof filteredPool[0].poolCurrency !== 'undefined'){
      //       if(cur.currency.name === filteredPool[0].poolCurrency.value){
      //         return cur
      //       }
      //     }
      //   });
      // }

      let addAccountButtonJsx;
      if (this._showAddAccountBtn) {
        addAccountButtonJsx = (
          <button className="gdocs-btn-default marg-bottom"
            disabled={this.props.customer.roleDetails.customer}
            onClick={this.addAccounts}>
            <i className="icon icon-add"></i>{this.state.basicDetailJson !== undefined ? this.translations(this.state.basicDetailJson.addAccountBtn) : ''}</button>
        );
      }

      let standAloneAccountjsx = [];
      if (this.state.basicDetailJson !== undefined) {
        for (var i = 1; i <= this.state.noOfAccount; i++) {
          standAloneAccountjsx.push(<div className="gdocs-stand-alone-form" key={i}>
            <div className="gdocs-stand-alone-wrapper">
              <div className="gdocs-stand-alone-position">
                {this.translations(this.state.basicDetailJson.account)} {i}
              </div>
              <div className="gdocs-stand-alone-position">
                {
                  (i > 1)
                    ? <span className="delete-btn" role="button" disabled={!this.props.customer.roleDetails.customer}>
                      <i
                        className="icon icon-bin"
                        disabled={!this.props.customer.roleDetails.customer}
                        onClick={this.props.customer.roleDetails.customer ? undefined : this.deleteAdditionUser.bind(this, i - 1)}
                      >
                      </i>
                    </span>
                    : ''
                }
                {
                  (<MultiLineSelect
                    defaultValue={this.translations(this.state.basicDetailJson.pleaseselect)}
                    requiredFields={{
                      "row1": ["accountType", "accountNumber", "branchCode", "currency", "location"],
                      "row2": ["accountHolder", "entityNameOther"],
                      "row3": ["bankName", "hsbcBankName", "accountTitle", "tempRefrenceId"]
                    }}

                    data={this.props.poolAccounts.filter(acc => acc.currency && acc.currency.name === this.state.poolCurrency) || []}
                    value={typeof this.state.selectedAccounts[i - 1] !== 'undefined' && this.state.selectedAccounts.length > 0 ? this.state.selectedAccounts[i - 1] : ''}
                    name="accounts"
                    multiAccount={true}
                    disabledOptions={this.state.selectedAccounts}
                    isDisable={this.props.customer.roleDetails.customer}
                    // onEdit={this.handleBasicAccountEditClick.bind(this, this.state.selectedAccounts[i - 1], `standAloneAccounts${i - 1}`)}
                    _onChange={this.handleAccountChangeBasicDetails.bind(this, i - 1)}
                  />)
                }
                {/* <span className="icon icon-add addicon"></span>
                <PersistLink
                  history={this.props.history}
                  state={this.state}
                  className={"mrg-left " + (this.props.customer.roleDetails.customer ? 'disabled' : '')}
                  to={`/case-body/create-new-other-account-np/${this.props.match.params.productId}`}
                  disabled={this.props.customer.roleDetails.customer}
                  data={`standAloneAccounts${i - 1}`}
                >
                  {this.translations(this.state.basicDetailJson.addOtherAccount)}
                </PersistLink> */}
              </div>
            </div>
          </div>);
        }
      }

      return (
        <div className="customer-details-container">
          <div className="pannel-heading-container">
            <div>
              <h2 className="pannel-heading">
                <span className="newPooltitle">{refrenceIdNew}</span>
              </h2>
              <div className="subPanelHeading">
                <p className="pannel-sub-heading">
                  {/* {this.translations(this.props.pageJson1.singleCurrency)} - {filterCurrency !== '' ? filterCurrency + '-' : ''} {`${poolLength !== undefined ? poolLength : ''} ${this.translations(this.props.pageJson1.accounts)}`} */}
                  {this.translations(this.props.pageJson1.singleCurrency)} - {`${poolLength !== undefined ? poolLength : ''} ${this.translations(this.props.pageJson1.accounts)}`}
                </p>
                <p className="optional-text">
                  <b>{this.translations(this.props.pageJson1.descriptionText)}</b>
                </p>
              </div>
            </div>
          </div>
          <div className="gdocs-clear-float"></div>
          <NavListAccordionWrapper open={this.props.displayTabIndex}>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`1. ${this.translations(this.state.subPoolJson.dynamic_accordion_list_subpool.accordion1)}`}
              status={this.state.status !== undefined ? this.state.status.basicDetailsAndAccounts.status : 'incomplete'}
              _onClick={this.getTabIndex.bind(this, '0')}
            >
              <div>
                {
                  this.state.basicDetailJson !== undefined && this.state.countries !== undefined && this.props.currency !== undefined
                    ? <div>
                      <div className="form-group row" id="glsAgentField">
                        <label className="col-lg-4" htmlFor="glsAgent">
                          {this.translations(this.state.basicDetailJson.poolCurrency)}
                        </label>
                        <div className="col-lg-8 colsm-12">
                          <div className="display-inline">
                            <SimpleDropdown
                              options={this.props.currency.classificationNodes}
                              showPleaseSelectOption={true}
                              value={this.state.poolCurrency}
                              name="poolCurrency"
                              _onChange={(e) => this.setState({
                                [e.target.name]: e.target.value,
                                selectedAccounts: []
                              })}
                              optionTextSelector="alphabeticalCode"
                              valueSelector="alphabeticalCode"
                              _onBlur={this.handleBlurEvt}
                              defaultValue={this.translations(this.state.basicDetailJson.pleaseselect)}
                              disabled={this.state.disableCurrencyList || this.props.customer.roleDetails.customer}
                            />
                            {
                              this.state.dropDownInvalid
                                ? (<div className="input-error-msg-section">
                                  <span className="icon icon-circle-delete-solid"></span>
                                  {this.translations(this.state.basicDetailJson.currencymanmsg)}
                                </div>
                                )
                                : ''
                            }
                          </div>
                        </div>
                      </div>
                      <div className="add-standalone-wrapper">
                        <div className="add-standalone-container">
                          <div className="pannel-heading-container">
                            <h2 className="pannel-heading">
                              {this.translations(this.state.basicDetailJson.accountInPool)}
                            </h2>
                          </div>
                          <div className="gdocs-clear-float"></div>
                          <div>{standAloneAccountjsx}</div>
                          <div className="gdocs-clear-float"></div>
                          <div>{addAccountButtonJsx}</div>
                        </div>
                      </div>
                      <div className="gdocs-clear-float"></div>
                      <div key="buttons-wrapper" className="form-buttons-save-section">
                        <div className="form-buttons-wrapper">
                          <button
                            className="gdocs-btn-submit"
                            onClick={this.onBasicDetailAndAccountTabDataSubmit}
                          >
                            {this.translations(this.state.basicDetailJson.saveRefresh)}
                          </button>
                        </div>
                      </div>
                    </div>
                    : ''
                }
              </div>
            </NavListAccordion>
            <NavListAccordion
              lang={this.props.lang.currentLang.lang}
              navAccHeading={`2. ${this.translations(this.state.subPoolJson.dynamic_accordion_list_subpool.accordion2)}`}
              status={this.state.status !== undefined ? this.state.status.advantageAllocationSettings.status : 'optional'}
              _onClick={this.getTabIndex.bind(this, '1')}
            >
              <div className="addresses-section">
                {
                  this.state.basicDetailJson !== undefined
                    ?
                    <div>
                      <div className="gdoc-addpool-advantag-container">
                        {this._render(pageJson)}
                        {this.state.selectedPoolAcc.map(this._renderBuniessCheckForm)}
                        <div className="gdocs-clear-float"></div>
                        <div key="buttons-wrapper" className="form-buttons-save-section">
                          <div className="form-buttons-wrapper">
                            <button
                              className="gdocs-btn-submit"
                              onClick={this.onAdvanceAllocationSettingTabDataSubmit}
                            >
                              {this.translations(this.state.basicDetailJson.saveRefresh)}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    : ''
                }
                <div className="gdocs-clear-float"></div>
              </div>
            </NavListAccordion>
          </NavListAccordionWrapper>
          <div className="save-btn-right">
            <button
              onClick={this.onFormSubmit}
              className='btn save-btn'
            >
              {this.translations(this.state.subPoolJson.page_title_mainTitle.saveAndReturn)}
            </button>
          </div>
        </div>
      );
    } else {
      return (<div>Loadling...</div>);
    }
  }
}

// Basic detail and Account
class basicDetailPayload {
  constructor(mode) {
    this.data = {};
    this.mode = mode;
    this.data.notionalPooling = {
      poolingStructure: {
        pools: [{}],
        standAloneAccount: []
      },
      interestOptimisations: null
    }
  }

  setPaylod(event, props, state) {
    if (Object.keys(this.data.notionalPooling.poolingStructure.pools[0]).length <= 0 && props.location.state.id === undefined) {
      this.data.notionalPooling.poolingStructure.pools = [
        {
          "poolCurrency": {
            "name": "",
            "value": ""
          },
          "accounts": [
          ],
          "id": state.genId,
          "lid": state.genId
        }
      ]
    }
    switch (event.target.name) {
      case "multiAccount":
        this.data.notionalPooling.poolingStructure.pools[0].accounts = event.target.value
        break;
      case "poolCurrency":
        this.data.notionalPooling.poolingStructure.pools[0].poolCurrency = { name: event.target.value, value: event.target.value }
        break;
      default:
    }

    // if (this.mode === 'edit') {
    //   let id = props.location.state.id;
    //   let pools = props.notionalPoolingdata.notionalPooling.poolingStructure.pools;
    //   let filteredPool = pools.filter(pool => pool.id === id);
    //   let lid = filteredPool[0].lid;
    //   this.data.notionalPooling.poolingStructure.pools[0].id = id;
    //   this.data.notionalPooling.poolingStructure.pools[0].lid = lid;
    //   this.data.notionalPooling.poolingStructure.standAloneAccount = props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount;
    // } else {
    //   this.data.notionalPooling.poolingStructure.pools[0].id = state.genId;
    //   this.data.notionalPooling.poolingStructure.pools[0].lid = state.genId;
    //   this.data.notionalPooling.poolingStructure.standAloneAccount = props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount;
    // }
  }

  getPayload() {
    return this.data;
  }

}

// Advance Allocation Setting
class advanceAllocationPayload {
  constructor(mode) {
    this.data = {};
    this.mode = mode;
    this.data.notionalPooling = {
      poolingStructure: {
        pools: [{}],
        standAloneAccount: []
      },
      interestOptimisations: null
    }
  }

  setPaylod(event, props, state) {
    if (Object.keys(this.data.notionalPooling.poolingStructure.pools[0]).length <= 0 && props.location.state.id === undefined) {
      this.data.notionalPooling.poolingStructure.pools = [
        {
          "poolCurrency": {
            "name": "",
            "value": ""
          },
          "accounts": [
          ],
          "id": state.genId,
          "lid": state.genId
        }
      ]
    }
    if (typeof this.data.notionalPooling.poolingStructure.pools[0].allocationSettings === 'undefined') {
      this.data.notionalPooling.poolingStructure.pools[0].allocationSettings = {
        interestCredit: {
          baseRate: state.allocationSettings.interestCredit.baseRate !== '' ? state.allocationSettings.interestCredit.baseRate : '',
          baseRateCode: state.allocationSettings.interestCredit.baseRateCode !== '' ? state.allocationSettings.interestCredit.baseRateCode : '',
          rate: state.allocationSettings.interestCredit.rate !== 'false' ? state.allocationSettings.interestCredit.rate : 'false',
          spread: state.allocationSettings.interestCredit.spread !== '' ? state.allocationSettings.interestCredit.spread : '',
          minimumInterest: state.allocationSettings.interestCredit.minimumInterest !== '' ? state.allocationSettings.interestCredit.minimumInterest : '',
          maximumInterest: state.allocationSettings.interestCredit.maximumInterest !== '' ? state.allocationSettings.interestCredit.maximumInterest : ''
        },
        interestDebit: {
          baseRate: state.allocationSettings.interestDebit.baseRate !== '' ? state.allocationSettings.interestDebit.baseRate : '',
          baseRateCode: state.allocationSettings.interestDebit.baseRateCode !== '' ? state.allocationSettings.interestDebit.baseRateCode : '',
          rate: state.allocationSettings.interestDebit.rate !== 'false' ? state.allocationSettings.interestDebit.rate : 'false',
          spread: state.allocationSettings.interestDebit.spread !== '' ? state.allocationSettings.interestDebit.spread : '',
          minimumInterest: state.allocationSettings.interestDebit.minimumInterest !== '' ? state.allocationSettings.interestDebit.minimumInterest : '',
          maximumInterest: state.allocationSettings.interestDebit.maximumInterest !== '' ? state.allocationSettings.interestDebit.maximumInterest : ''
        },
        unauthorisedOD: {
          baseRate: state.allocationSettings.unauthorisedOD.baseRate !== '' ? state.allocationSettings.unauthorisedOD.baseRate : '',
          baseRateCode: state.allocationSettings.unauthorisedOD.baseRateCode !== '' ? state.allocationSettings.unauthorisedOD.baseRateCode : '',
          rate: state.allocationSettings.unauthorisedOD.rate !== 'false' ? state.allocationSettings.unauthorisedOD.rate : 'false',
          spread: state.allocationSettings.unauthorisedOD.spread !== '' ? state.allocationSettings.unauthorisedOD.spread : '',
          minimumInterest: state.allocationSettings.unauthorisedOD.minimumInterest !== '' ? state.allocationSettings.unauthorisedOD.minimumInterest : '',
          maximumInterest: state.allocationSettings.unauthorisedOD.maximumInterest !== '' ? state.allocationSettings.unauthorisedOD.maximumInterest : '',
          interestRateType: state.allocationSettings.unauthorisedOD.interestRateType !== 'true' ? state.allocationSettings.unauthorisedOD.interestRateType : 'true'
        },
        odLimit: state.allocationSettings.odLimit,
        allocationMethod: state.allocationSettings.allocationMethod,
        defaultSettlementAccount: state.allocationSettings.defaultSettlementAccount
      }
    }

    switch (event.target.name) {
      case "poolCurrency":
        this.data.notionalPooling.poolingStructure.pools[0].poolCurrency = { name: event.target.value, value: event.target.value }
        break;
      case "poolId":
        this.data.notionalPooling.poolingStructure.pools[0].poolId = event.target.value;
        break;
      case "allocationMethod":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.allocationMethod = event.target.value;
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.other = '';
        if (event.target.value === 'N/A') {
          this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.defaultSettlementAccount = 'SameAsAbove'
        } else {
          this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.defaultSettlementAccount = 'Other'
        }
        break;
      case "defaultSettlementAccount":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.defaultSettlementAccount = event.target.value;
        break;
      case "nominatedPoolingAccount":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.nominatedPoolingAccount = event.target.value;
        break;
      case "other":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.other = event.target.value;
        break;
      case 'interestCredit':
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.interestCredit = event.target.value;
        break;
      case 'interestDebit':
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.interestDebit = event.target.value;
        break;
      case "odLimit":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.odLimit = state.allocationSettings.odLimit
        break;
      case "unauthorisedOD":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.unauthorisedOD = event.target.value;
        break;
      case "accountSettings":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.accountSettings = event.target.value;
        break;
    }

    if (this.mode === 'edit') {
      let id = props.location.state.id;
      let pools = props.notionalPoolingdata.notionalPooling.poolingStructure.pools;
      // let pools = sowNotionalPoolJson.notionalPooling.poolingStructure.pools;
      let filteredPool = pools.filter(pool => pool.id === id);
      let lid = filteredPool[0].lid;
      this.data.notionalPooling.poolingStructure.pools[0].id = id;
      this.data.notionalPooling.poolingStructure.pools[0].lid = lid;
      this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.other = state.allocationSettings.other;
      this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.nominatedPoolingAccount = state.allocationSettings.nominatedPoolingAccount;
      this.data.notionalPooling.poolingStructure.standAloneAccount = props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount;
    } else {
      this.data.notionalPooling.poolingStructure.pools[0].id = state.genId;
      this.data.notionalPooling.poolingStructure.pools[0].lid = state.genId;
      this.data.notionalPooling.poolingStructure.standAloneAccount = props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount;
    }
  }

  getPayload() {
    return this.data;
  }
}

class addPoolPayload {
  constructor(mode) {
    this.data = {};
    this.mode = mode;
    this.data.notionalPooling = {
      poolingStructure: {
        pools: [{}]
      },
      interestOptimisations: null
    }

  }
  setPrePopulateData(standAloneAccount) {
    this.data.notionalPooling.poolingStructure.standAloneAccount = standAloneAccount;
  }
  setPrePopulateAllocationSettings(allocationSettings) {
    this.data.notionalPooling.poolingStructure.pools[0].allocationSettings = allocationSettings;
  }
  setPaylod(event, props, state) {
    if (Object.keys(this.data.notionalPooling.poolingStructure.pools[0]).length <= 0 && props.location.state.id === undefined) {
      this.data.notionalPooling.poolingStructure.pools = [
        {
          "poolCurrency": {
            "name": "",
            "value": ""
          },
          "accounts": [
          ],
          "id": state.genId,
          "lid": state.genId
        }
      ]
    }
    if (typeof this.data.notionalPooling.poolingStructure.pools[0].allocationSettings === 'undefined') {
      this.data.notionalPooling.poolingStructure.pools[0].allocationSettings = {
        interestCredit: {
          baseRate: state.allocationSettings.interestCredit.baseRate !== '' ? state.allocationSettings.interestCredit.baseRate : '',
          baseRateCode: state.allocationSettings.interestCredit.baseRateCode !== '' ? state.allocationSettings.interestCredit.baseRateCode : '',
          rate: state.allocationSettings.interestCredit.rate !== 'false' ? state.allocationSettings.interestCredit.rate : 'false',
          spread: state.allocationSettings.interestCredit.spread !== '' ? state.allocationSettings.interestCredit.spread : '',
          minimumInterest: state.allocationSettings.interestCredit.minimumInterest !== '' ? state.allocationSettings.interestCredit.minimumInterest : '',
          maximumInterest: state.allocationSettings.interestCredit.maximumInterest !== '' ? state.allocationSettings.interestCredit.maximumInterest : ''
        },
        interestDebit: {
          baseRate: state.allocationSettings.interestDebit.baseRate !== '' ? state.allocationSettings.interestDebit.baseRate : '',
          baseRateCode: state.allocationSettings.interestDebit.baseRateCode !== '' ? state.allocationSettings.interestDebit.baseRateCode : '',
          rate: state.allocationSettings.interestDebit.rate !== 'false' ? state.allocationSettings.interestDebit.rate : 'false',
          spread: state.allocationSettings.interestDebit.spread !== '' ? state.allocationSettings.interestDebit.spread : '',
          minimumInterest: state.allocationSettings.interestDebit.minimumInterest !== '' ? state.allocationSettings.interestDebit.minimumInterest : '',
          maximumInterest: state.allocationSettings.interestDebit.maximumInterest !== '' ? state.allocationSettings.interestDebit.maximumInterest : ''
        },
        unauthorisedOD: {
          baseRate: state.allocationSettings.unauthorisedOD.baseRate !== '' ? state.allocationSettings.unauthorisedOD.baseRate : '',
          baseRateCode: state.allocationSettings.unauthorisedOD.baseRateCode !== '' ? state.allocationSettings.unauthorisedOD.baseRateCode : '',
          rate: state.allocationSettings.unauthorisedOD.rate !== 'false' ? state.allocationSettings.unauthorisedOD.rate : 'false',
          spread: state.allocationSettings.unauthorisedOD.spread !== '' ? state.allocationSettings.unauthorisedOD.spread : '',
          minimumInterest: state.allocationSettings.unauthorisedOD.minimumInterest !== '' ? state.allocationSettings.unauthorisedOD.minimumInterest : '',
          maximumInterest: state.allocationSettings.unauthorisedOD.maximumInterest !== '' ? state.allocationSettings.unauthorisedOD.maximumInterest : '',
          interestRateType: state.allocationSettings.unauthorisedOD.interestRateType !== 'true' ? state.allocationSettings.unauthorisedOD.interestRateType : 'true'
        },
        odLimit: state.allocationSettings.odLimit,
        allocationMethod: state.allocationSettings.allocationMethod,
        defaultSettlementAccount: state.allocationSettings.defaultSettlementAccount
      }
    }

    switch (event.target.name) {
      case "poolCurrency":
        this.data.notionalPooling.poolingStructure.pools[0].poolCurrency = { name: event.target.value, value: event.target.value }
        break;
      case "poolId":
        this.data.notionalPooling.poolingStructure.pools[0].poolId = event.target.value;
        break;
      case "multiAccount":
        this.data.notionalPooling.poolingStructure.pools[0].accounts = event.target.value
        break;
      case "allocationMethod":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.allocationMethod = event.target.value;
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.other = '';
        if (event.target.value === 'N/A') {
          this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.defaultSettlementAccount = 'SameAsAbove'
        } else {
          this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.defaultSettlementAccount = 'Other'
        }
        break;
      case "defaultSettlementAccount":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.defaultSettlementAccount = event.target.value;
        break;
      case "nominatedPoolingAccount":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.nominatedPoolingAccount = event.target.value;
        break;
      case "other":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.other = event.target.value;
        break;
      case 'interestCredit':
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.interestCredit = event.target.value;
        break;
      case 'interestDebit':
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.interestDebit = event.target.value;
        break;
      case "odLimit":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.odLimit = event.target.checked ? 'N/A' : event.target.value;
        break;
      case "unauthorisedOD":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.unauthorisedOD = event.target.value;
        break;
      case "accountSettings":
        this.data.notionalPooling.poolingStructure.pools[0].allocationSettings.accountSettings = event.target.value;
        break;
    }

    // if (this.mode === 'edit') {
    //   let id = props.location.state.id;
    //   let pools = sowNotionalPoolJson.notionalPooling.poolingStructure.pools;
    //   let filteredPool = pools.filter(pool => pool.id === id);
    //   let lid = filteredPool[0].lid;
    //   this.data.notionalPooling.poolingStructure.pools[0].id = id;
    //   this.data.notionalPooling.poolingStructure.pools[0].lid = lid;
    // } else {
    //   this.data.notionalPooling.poolingStructure.pools[0].id = state.genId;
    //   this.data.notionalPooling.poolingStructure.pools[0].lid = state.genId;
    // }

  }
  getPayload() {
    return this.data;
  }
}

const mapStateToProps = state => {
  let poolAccounts = []
  const { location = {}, notionalPooling = {} } = (state.sowEntities && state.sowEntities.selectedSowProduct) || {}
  if (state.sowEntities.allAccounts) {
    poolAccounts = state.sowEntities.allAccounts.filter(acc => acc.location && (acc.location.value === location.value))
  }

  return {
    notionalPoolingdata: (state.sowEntities && state.sowEntities.selectedSowProduct) || {},
    statuses: state.currentProductNotionalPooling.statuses,
    currency: state.currentProductNotionalPooling.currency,
    basicDetailsAccounts: poolAccounts,
    cases: state.cases,
    pageJson1: state.currentProductNotionalPooling.pageJson1,
    lang: state.lang,
    customer: state.auth.userDetails,
    PoolIdAfterSaveReferesh: state.currentProductNotionalPooling.poolIdAfterSaveRefresh,
    state: state,
    accounts: poolAccounts,
    displayTabIndex: state.currentProductNotionalPooling.activePoolTabIndex,
    selectedSowProduct: (state.sowEntities && state.sowEntities.selectedSowProduct) || {},
    poolAccounts
  }
}
const mapDispatchToProps = dispatch => {
  return {
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
    setPoolIdAfterSaveReferesh: pooId => {
      dispatch(setPoolIdAfterSaveReferesh(pooId))
    },
    setProductNotionalPooling: data => {
      dispatch(setProductNotionalPooling(data))
    },
    setBasicDetailAcc: accounts => {
      dispatch(setBasicDetailAcc(accounts))
    },
    setNewPoolActiveTabIndex: index => {
      dispatch(setNewPoolActiveTabIndex(index))
    },
    reSetNewPoolActiveTabIndex: () => {
      dispatch(reSetNewPoolActiveTabIndex())
    },
    setSowSelectedProduct: data => {
      dispatch(setSowSelectedProduct(data));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(SowAddPool);



// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/NotionalPoolSummary/GlsNotionalPoolingStrucutre/AddPool/index.js